<template>
  <v-card class="rsl-fixed-height">
    <v-tabs v-model="tab">
      <v-tab @click="resetStyle()">
        {{ $t('FORMS.NEW_EDIT_FORM.TABS.BUILD') }}
      </v-tab>
      <v-tab @click="buildSchema('build')">
        {{ $t('FORMS.NEW_EDIT_FORM.TABS.PREVIEW') }}
      </v-tab>
    </v-tabs>

    <!-- BUILD -->
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-btn
          v-if="formAction != 'view'"
          small
          class="mr-2 ma-3"
          color="error"
          @click="resetForm()"
        >{{ $t('FORMS.NEW_EDIT_FORM.BTNS.RESET') }}</v-btn>
        <v-btn
          small
          class="mr-2 ma-3"
          color="warning"
          @click="exportForm()"
        >{{ $t('FORMS.NEW_EDIT_FORM.BTNS.EXPORT') }}</v-btn>
        <v-btn
          v-if="formAction != 'view'"
          small
          class="mr-2 ma-3"
          color="success"
          :disabled="!isFormValid"
          @click="buildSchema('save')"
        >{{ $t('FORMS.NEW_EDIT_FORM.BTNS.SAVE') }}</v-btn>
        <v-btn
          v-if="formAction != 'view'"
          small
          class="mr-2 ma-3"
          color="secondary"
          :disabled="!isFormValid"
          @click="closeForm('')"
        >{{ $t('FORMS.NEW_EDIT_FORM.BTNS.CLOSE') }}</v-btn>
        <v-btn
          v-if="formAction == 'view'"
          small
          class="mr-2 ma-3"
          color="secondary"
          @click="closeForm('view')"
        >{{ $t('FORMS.NEW_EDIT_FORM.BTNS.CLOSE') }}</v-btn>
        <v-container class="build-content" id="content-container">
          <v-form v-model="isFormValid">
            <v-row v-if="formAction != 'view'">
              <v-col md="3">
                <v-select @change="loadProcessVars()" :items="allProcessXml" item-text="PROCESS_NAME" item-value="PROCESS_KEY" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.SELECT_PROCESS')" v-model="processKey" :rules="[rules.requiredSelect]"></v-select>
              </v-col>

              <v-col md="3">
                <v-select :items="versionFilter" item-text="VERSION" item-value="VERSION" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.SELECT_VERSION')" v-model="processVersion" :rules="[rules.requiredSelect]"></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col :md="12">
                <v-card class="pa-5">
                  <v-card-title>
                    <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.FORM_TITLE')" v-model="formTitle" :disabled="formAction == 'view'" :rules="[rules.required]"></v-text-field>
                  </v-card-title>
                  <v-btn
                    class="mb-2"
                    color="warning"
                    @click="queryDialog = true"
                  >{{ $t('FORMS.NEW_EDIT_FORM.BTNS.QUERIES') }}</v-btn>
                  <v-btn
                      class="mb-2 float-right"
                      color="warning"
                      @click="openJsEditor()"
                    >{{ $t('FORMS.NEW_EDIT_FORM.BTNS.EDITOR') }}</v-btn>
                  <!-- GRID -->
                  <div id="content">
                    <grid-layout
                      ref="gridlayout"
                      :layout.sync="layout"
                      :col-num="12"
                      :row-height="50"
                      :is-draggable="true"
                      :is-resizable="true"
                      :is-mirrored="false"
                      :vertical-compact="false"
                      :use-css-transforms="false"
                      :prevent-collision="true"
                    >

                      <grid-item v-for="item in layout"
                        :x="item.x"
                        :y="item.y"
                        :w="item.w"
                        :h="item.h"
                        :maxH="1"
                        :i="item.i"
                        :key="item.i"
                        :is-resizable="item.data.varType != 'checkbox' && item.data.varType != 'radio' && item.data.varType != 'page' && item.data.varType != 'subform' && !item.isLocked"
                        :static="item.data.varType == 'group' || item.isLocked"
                        @moved="dragMoved(item)"
                        @resized="dragResized(item)"
                        class="pl-8">
                          <span class="truncate element-type">{{item.elementType}}</span> <span class="truncate">{{item.data.varLabel}}</span> <span class="edit-element" @click="editElement(item)"><v-icon class="mdi mdi-lead-pencil"></v-icon></span><span class="lock-element" @click="lockElement(item)"><v-icon v-if="!item.isLocked" class="mdi mdi-lock-open-outline"></v-icon><v-icon v-if="item.isLocked" color="orange" class="mdi mdi-lock"></v-icon></span>
                      </grid-item>
                    </grid-layout>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
        <!-- NEW FORM ELEMENTS -->
        <v-speed-dial
            v-model="addBtn"
            absolute
            bottom
            right
            elevation="2"
            direction="left"
            fab
            transition="slide-x-reverse-transition"
          >
            <template v-slot:activator>
              <v-btn
                v-model="addBtn"
                color="#f87723"
                dark
                fab
              >
                <v-icon v-if="addBtn">
                  mdi-close
                </v-icon>
                <v-icon v-else>
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <div>
              <v-btn
                color="#f87723"
                small
                @click="addField('page', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.DIVIDER.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.DIVIDER') }}
              </v-btn>
              <v-btn
                color="#f87723"
                small
                @click="addField('file', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.FILE_UPLOADER.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.FILE_UPLOADER') }}
              </v-btn>
              <v-btn
                color="#f87723"
                small
                @click="addField('subheader', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SUBTITLE.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.SUBTITLE') }}
              </v-btn>
            </div>
            <div>
              <v-btn
                color="#f87723"
                small
                @click="addField('para', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.PARAGRAPH.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.PARAGRAPH') }}
              </v-btn>
              <v-btn
                color="#f87723"
                small
                @click="addField('text', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.TEXT.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.TEXT') }}
              </v-btn>
              <v-btn
                color="#f87723"
                small
                @click="addField('textarea', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.TEXTAREA.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.TEXTAREA') }}
              </v-btn>
            </div>
            <div>
              <v-btn
                color="#f87723"
                small
                @click="addField('number', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.NUMBER.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.NUMBER') }}
              </v-btn>
              <v-btn
                color="#f87723"
                small
                @click="addField('select', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.SELECT') }}
              </v-btn>
              <v-btn
                color="#f87723"
                small
                @click="addField('autocomplete', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.AUTOCOMPLETE.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.AUTOCOMPLETE') }}
              </v-btn>
            </div>
            <div>
              <v-btn
                color="#f87723"
                small
                @click="addField('combobox', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.COMBOBOX.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.COMBOBOX') }}
              </v-btn>
              <v-btn
                color="#f87723"
                small
                @click="addField('date', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.DATE.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.DATE') }}
              </v-btn>
              <v-btn
                color="#f87723"
                small
                @click="addField('time', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.TIME.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.TIME') }}
              </v-btn>
            </div>
            <div>
              <v-btn
                color="#f87723"
                small
                @click="addField('radio', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.RADIO.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.RADIO') }}
              </v-btn>
              <v-btn
                color="#f87723"
                small
                @click="addField('checkbox', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.CHECKBOX') }}
              </v-btn>
              <v-btn
                color="#f87723"
                small
                @click="addField('link', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.LINK.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.LINK') }}
              </v-btn>
            </div>
            <div>
              <v-btn
                color="#f87723"
                small
                @click="addField('img', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.IMAGE.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.IMAGE') }}
              </v-btn>
              <v-btn
                color="#f87723"
                small
                @click="addField('array', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.GRID.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.GRID') }}
              </v-btn>
              <v-btn
                color="#f87723"
                small
                @click="addField('subform', $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SUBFORM.LABEL'))">
                {{ $t('FORMS.NEW_EDIT_FORM.BTNS.SUBFORM') }}
              </v-btn>
            </div>
          </v-speed-dial>

        <!-- DIALOGS -->
        <v-dialog
          transition="dialog-bottom-transition"
          max-width="800"
          v-model="newElementDialog"
          :retain-focus="false"
          persistent
        >
          <template>
            <v-card>
              <v-toolbar
                color="#f87723"
                dark
              >{{ newElementTitle }}</v-toolbar>
              <v-card-text>
                <div class="pt-5">{{ newElementText }}</div>
                <v-form v-model="isFieldValid" ref="newElement">
                  <v-row v-if="varType != 'group' && varType != 'page' && varType != 'title' && varType != 'subheader' && varType != 'para' && varType != 'subform'">
                    <v-col cols="12" sm="12">
                      <v-combobox :items="varFilter" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.VAR_NAME')" v-model="varName" :rules="[rules.required, rules.noSpaces]"></v-combobox>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType != 'page' && varType != 'subform' && varType != 'title' && varType != 'para' && varType != 'img' && varType != 'link' && varType != 'array'">
                    <v-col cols="12" sm="12">
                      <v-text-field :label="varType == 'group' || varType == 'subheader' ? $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SUBTITLE.LABEL') : $t('FORMS.NEW_EDIT_FORM.FIELDS.FIELD_LABEL')" v-model="varLabel" :rules="varType == 'subheader' ? [rules.required] : []"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'para' || varType == 'page'">
                    <v-col cols="12" sm="12">
                      <v-textarea v-if="varType == 'para'" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.PARAGRAPH.FIELDS.TITLE')" v-model="varLabel"></v-textarea>
                      <v-text-field v-if="varType == 'page'" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.DIVIDER.FIELDS.TITLE')" v-model="varLabel" :rules="[rules.required]"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'link'">
                    <v-col cols="12" sm="12">
                      <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.LINK.FIELDS.LINK_TEXT')" v-model="varLabel" :rules="[rules.required]"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'img' || varType == 'link'">
                    <v-col cols="12" sm="12">
                      <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.URL')" v-model="varUrl" :rules="[rules.required]"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'img'">
                    <v-col cols="6" sm="6">
                      <v-text-field type="number" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.IMAGE.FIELDS.HEIGHT')" v-model="varMaxH"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6">
                      <v-text-field type="number" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.IMAGE.FIELDS.WIDTH')" v-model="varMaxW"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'date'">
                    <v-col cols="6" sm="6">
                      <v-menu
                        ref="minMenu"
                        v-model="minMenu"
                        :close-on-content-click="false"
                        :return-value.sync="minDate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.DATE.FIELDS.MIN_DATE')" v-model="minDate" readonly v-bind="attrs" v-on="on" clearable></v-text-field>
                        </template>
                        <v-date-picker v-model="minDate" no-title :locale="$t('GENERAL.LOCALE')">
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="secondary"
                            @click="minMenu = false"
                          >
                            {{ $t('GENERAL.BTNS.CANCEL') }}
                          </v-btn>
                          <v-btn
                            text
                            color="secondary"
                            @click="$refs.minMenu.save(minDate)"
                          >
                            {{ $t('GENERAL.BTNS.OK') }}
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6" sm="6">
                      <v-menu
                        ref="maxMenu"
                        v-model="maxMenu"
                        :close-on-content-click="false"
                        :return-value.sync="maxDate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.DATE.FIELDS.MAX_DATE')" v-model="maxDate" readonly v-bind="attrs" v-on="on" clearable></v-text-field>
                        </template>
                        <v-date-picker v-model="maxDate" no-title :locale="$t('GENERAL.LOCALE')">
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="secondary"
                            @click="maxMenu = false"
                          >
                            {{ $t('GENERAL.BTNS.CANCEL') }}
                          </v-btn>
                          <v-btn
                            text
                            color="secondary"
                            @click="$refs.maxMenu.save(maxDate)"
                          >
                            {{ $t('GENERAL.BTNS.OK') }}
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'time'">
                    <v-col cols="6" sm="6">
                      <v-menu
                        ref="minMenu"
                        v-model="minMenu"
                        :close-on-content-click="false"
                        :return-value.sync="minTime"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.TIME.FIELDS.MIN_TIME')" v-model="minTime" readonly v-bind="attrs" v-on="on" clearable></v-text-field>
                        </template>
                        <v-time-picker v-model="minTime" no-title format="24hr">
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="secondary"
                            @click="minMenu = false"
                          >
                            {{ $t('GENERAL.BTNS.CANCEL') }}
                          </v-btn>
                          <v-btn
                            text
                            color="secondary"
                            @click="$refs.minMenu.save(minTime)"
                          >
                            {{ $t('GENERAL.BTNS.OK') }}
                          </v-btn>
                        </v-time-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6" sm="6">
                      <v-menu
                        ref="maxMenu"
                        v-model="maxMenu"
                        :close-on-content-click="false"
                        :return-value.sync="maxTime"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.TIME.FIELDS.MAX_TIME')" v-model="maxTime" readonly v-bind="attrs" v-on="on" clearable></v-text-field>
                        </template>
                        <v-time-picker v-model="maxTime" no-title format="24hr">
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="secondary"
                            @click="maxMenu = false"
                          >
                            {{ $t('GENERAL.BTNS.CANCEL') }}
                          </v-btn>
                          <v-btn
                            text
                            color="secondary"
                            @click="$refs.maxMenu.save(maxTime)"
                          >
                            {{ $t('GENERAL.BTNS.OK') }}
                          </v-btn>
                        </v-time-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'time'">
                    <v-col cols="12" sm="12">
                      <v-switch color="success" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.TIME.FIELDS.FORMAT')" v-model="varIs24"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'text' || varType == 'textarea' || varType == 'number'">
                    <v-col cols="12" sm="12">
                      <v-text-field v-if="varType == 'text'" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.DEFAULT_VAL')" v-model="varValue"></v-text-field>
                      <v-textarea v-if="varType == 'textarea'" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.DEFAULT_VAL')" v-model="varValue"></v-textarea>
                      <v-text-field v-if="varType == 'number'" type="number" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.DEFAULT_VAL')" v-model="varValue"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'text'">
                    <v-col cols="12" sm="12">
                      <v-switch color="success" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.TEXT.FIELDS.IS_EMAIL')" v-model="varIsEmail"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'number'">
                    <v-col cols="12" sm="12">
                      <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.NUMBER.FIELDS.AUTO_CALC')" v-model="varAutocalc"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'subform'">
                    <v-col cols="12" sm="12">
                      <v-select :items="subformList" item-text="FORM_TITLE" item-value="FORM_KEY" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SUBFORM.FIELDS.FORM')" v-model="subform" :rules="[rules.requiredSelect]"></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'radio'">
                    <v-col cols="12" sm="12">
                      <v-data-table :headers="radioHeaders" :items="radioItems" item-key="id">
                        <template slot="top">
                          <v-toolbar
                            color="#2c3a47"
                            dark
                          >{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.RADIO.ADD_REMOVE') }}
                            <v-spacer></v-spacer>
                            <v-btn
                              small
                              class="mr-2"
                              color="success"
                              @click="addNewRow()"
                            ><v-icon medium>mdi-plus</v-icon></v-btn>
                          </v-toolbar>
                        </template>
                        <template slot="item.actions" slot-scope="row">
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="error"
                            @click="deleteRow(row.item.id)"
                          ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="warning"
                            @click="editRow(row.item.id)"
                          ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == radioItems.length - 1"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemDown(row.item.id, 'radioItems')"
                          ><v-icon medium>mdi-arrow-down-bold</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == 0"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemUp(row.item.id, 'radioItems')"
                          ><v-icon medium>mdi-arrow-up-bold</v-icon></v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'select' || varType == 'autocomplete'">
                    <v-col cols="12" sm="12">
                      <v-data-table :headers="selectHeaders" :items="selectItems" item-key="id">
                        <template slot="top">
                          <v-toolbar
                            color="#2c3a47"
                            dark
                          ><span v-if="varType == 'select'">{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.ADD_REMOVE') }}</span>
                           <span v-if="varType == 'autocomplete'">{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.AUTOCOMPLETE.ADD_REMOVE') }}</span>
                            <v-spacer></v-spacer>
                            <v-btn
                              small
                              class="mr-2"
                              color="success"
                              @click="addNewRow()"
                            ><v-icon medium>mdi-plus</v-icon></v-btn>
                          </v-toolbar>
                        </template>
                        <template slot="item.actions" slot-scope="row">
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="error"
                            @click="deleteRow(row.item.id)"
                          ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="warning"
                            @click="editRow(row.item.id)"
                          ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == selectItems.length - 1"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemDown(row.item.id, 'selectItems')"
                          ><v-icon medium>mdi-arrow-down-bold</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == 0"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemUp(row.item.id, 'selectItems')"
                          ><v-icon medium>mdi-arrow-up-bold</v-icon></v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'checkbox'">
                    <v-col cols="12" sm="12">
                      <v-data-table :headers="checkboxHeaders" :items="checkboxItems" item-key="id">
                        <template slot="top">
                          <v-toolbar
                            color="#2c3a47"
                            dark
                          >{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.ADD_REMOVE') }}
                            <v-spacer></v-spacer>
                            <v-btn
                              small
                              class="mr-2"
                              color="success"
                              @click="addNewRow()"
                            ><v-icon medium>mdi-plus</v-icon></v-btn>
                          </v-toolbar>
                        </template>
                        <template slot="item.isRequired" slot-scope="row">
                          <v-switch color="success" v-model="row.item.isRequired"></v-switch>
                        </template>
                        <template slot="item.isChecked" slot-scope="row">
                          <v-switch color="success" v-model="row.item.isChecked"></v-switch>
                        </template>
                        <template slot="item.actions" slot-scope="row">
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="error"
                            @click="deleteRow(row.item.id)"
                          ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="warning"
                            @click="editRow(row.item.id)"
                          ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == checkboxItems.length - 1"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemDown(row.item.id, 'checkboxItems')"
                          ><v-icon medium>mdi-arrow-down-bold</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == 0"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemUp(row.item.id, 'checkboxItems')"
                          ><v-icon medium>mdi-arrow-up-bold</v-icon></v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'combobox'">
                    <v-col cols="12" sm="12">
                      <v-data-table :headers="comboHeaders" :items="comboItems" item-key="id">
                        <template slot="top">
                          <v-toolbar
                            color="#2c3a47"
                            dark
                          >{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.COMBOBOX.ADD_REMOVE') }}
                            <v-spacer></v-spacer>
                            <v-btn
                              small
                              class="mr-2"
                              color="success"
                              @click="addNewRow()"
                            ><v-icon medium>mdi-plus</v-icon></v-btn>
                          </v-toolbar>
                        </template>
                        <template slot="item.actions" slot-scope="row">
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="error"
                            @click="deleteRow(row.item.id)"
                          ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="warning"
                            @click="editRow(row.item.id)"
                          ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == comboItems.length - 1"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemDown(row.item.id, 'comboItems')"
                          ><v-icon medium>mdi-arrow-down-bold</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == 0"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemUp(row.item.id, 'comboItems')"
                          ><v-icon medium>mdi-arrow-up-bold</v-icon></v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'array'">
                    <v-col cols="12" sm="12">
                      <v-data-table :headers="gridHeaders" :items="gridItems" item-key="id">
                        <template slot="top">
                          <v-toolbar
                            color="#2c3a47"
                            dark
                          >{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.GRID.ADD_REMOVE') }}
                            <v-spacer></v-spacer>
                            <v-btn
                              small
                              class="mr-2"
                              color="success"
                              @click="addNewRow()"
                            ><v-icon medium>mdi-plus</v-icon></v-btn>
                          </v-toolbar>
                        </template>
                        <template slot="item.actions" slot-scope="row">
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="error"
                            @click="deleteRow(row.item.id)"
                          ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="warning"
                            @click="editRow(row.item.id)"
                          ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == gridItems.length - 1"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemDown(row.item.id, 'gridItems')"
                          ><v-icon medium>mdi-arrow-down-bold</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == 0"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemUp(row.item.id, 'gridItems')"
                          ><v-icon medium>mdi-arrow-up-bold</v-icon></v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'array'">
                    <v-col cols="6" sm="6">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.GRID.FIELDS.ALLOW_ADD')" color="success" v-model="allowAdd"></v-switch>
                    </v-col>
                    <v-col cols="6" sm="6">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.GRID.FIELDS.ALLOW_DELETE')" color="success" v-model="allowDelete"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType != 'group' && varType != 'page' && varType != 'title' && varType != 'subheader' && varType != 'subform' && varType != 'array' && varType != 'img' && varType != 'link'">
                    <v-col cols="12" sm="12">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.ENABLE_SQL')" color="warning" v-model="enableSql"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="enableSql">
                    <v-col cols="12" sm="12">
                      <v-select :items="allDbConns" item-text="name" item-value="val" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.AM_DATABASE')" v-model="fieldConnId"></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="enableSql">
                    <v-col cols="12" sm="12">
                      <v-text-field v-model="fieldSql" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.AM_SQL')"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'radio'">
                    <v-col cols="12" sm="12">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.RADIO.FIELDS.AS_ROW')" color="success" v-model="radioAsRow"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'select'">
                    <v-col cols="12" sm="12">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.FIELDS.IS_MULTI')" color="success" v-model="varAllowMultiple"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'file'">
                    <v-col cols="12" sm="12">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.FILE_UPLOADER.FIELDS.IS_MULTI')" color="success" v-model="varAllowMultiple"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType != 'group' && varType != 'page' && varType != 'title' && varType != 'subheader' && varType != 'para' && varType != 'link' && varType != 'img' && varType != 'subform' && varType != 'array'">
                    <v-col cols="12" sm="12">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.IS_REQUIRED')" color="success" v-model="varRequired"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType != 'group' && varType != 'page' && varType != 'title' && varType != 'para' && varType != 'subform'">
                    <v-col cols="12" sm="12">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.IS_HIDDEN')" color="success" v-model="varHidden"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType != 'group' && varType != 'page' && varType != 'title' && varType != 'subheader' && varType != 'para' && varType != 'link' && varType != 'img'">
                    <v-col cols="12" sm="12">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.IS_DISABLED')" color="success" v-model="varDisabled"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'subform'">
                    <v-col cols="6" sm="6">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SUBFORM.FIELDS.SOLID_BORDER')" color="success" v-model="varBorderSolid"></v-switch>
                    </v-col>
                    <v-col cols="6" sm="6">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SUBFORM.FIELDS.DASHED_BORDER')" color="success" v-model="varBorderDashed"></v-switch>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  text
                  @click="cancelNewElement"
                >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  :disabled="!isFieldValid"
                  @click="verifyField({varType, varName, varLabel, minDate, maxDate, minTime, maxTime, varIs24, varValue, varIsEmail, varUrl, varMaxH, varMaxW, subform, varWidth, varOffset, varAutocalc, allowAdd, allowDelete, fieldConnId, fieldSql, radioAsRow, varAllowMultiple, varRequired, varHidden, varDisabled, varBorderSolid, varBorderDashed})"
                >{{ $t('GENERAL.BTNS.ADD') }}</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>

        <v-dialog
          transition="dialog-bottom-transition"
          max-width="800"
          v-model="editElementDialog"
          :retain-focus="false"
          persistent
        >
          <template>
            <v-card>
              <v-toolbar
                color="#f87723"
                dark
              >{{ editElementTitle }}
                <v-spacer></v-spacer>
                <v-btn
                  v-if="formAction != 'view'"
                  small
                  class="mr-2"
                  color="error"
                  @click="deleteField(currentElementId)"
                >{{ $t('GENERAL.BTNS.DELETE') }}</v-btn>
              </v-toolbar>
              <v-card-text>
                <div class="pt-5">{{ editElementText }}</div>
                <v-form v-model="isFieldValid" ref="editElement">
                  <v-row v-if="varType != 'group' && varType != 'page' && varType != 'title' && varType != 'subheader' && varType != 'para' && varType != 'subform'">
                    <v-col cols="12" sm="12">
                      <v-combobox :items="varFilter" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.VAR_NAME')" v-model="varName" :rules="[rules.required, rules.noSpaces]"></v-combobox>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType != 'page' && varType != 'subform' && varType != 'title' && varType != 'para' && varType != 'img' && varType != 'link' && varType != 'array'">
                    <v-col cols="12" sm="12">
                      <v-text-field :label="varType == 'group' || varType == 'subheader' ? $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SUBTITLE.LABEL') : $t('FORMS.NEW_EDIT_FORM.FIELDS.FIELD_LABEL')" v-model="varLabel" :rules="varType == 'subheader' ? [rules.required] : []"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'para' || varType == 'page'">
                    <v-col cols="12" sm="12">
                      <v-textarea v-if="varType == 'para'" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.PARAGRAPH.FIELDS.TITLE')" v-model="varLabel"></v-textarea>
                      <v-text-field v-if="varType == 'page'" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.DIVIDER.FIELDS.TITLE')" v-model="varLabel" :rules="[rules.required]"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'link'">
                    <v-col cols="12" sm="12">
                      <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.LINK.FIELDS.LINK_TEXT')" v-model="varLabel" :rules="[rules.required]"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'img' || varType == 'link'">
                    <v-col cols="12" sm="12">
                      <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.URL')" v-model="varUrl" :rules="[rules.required]"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'img'">
                    <v-col cols="6" sm="6">
                      <v-text-field type="number" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.IMAGE.FIELDS.HEIGHT')" v-model="varMaxH"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6">
                      <v-text-field type="number" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.IMAGE.FIELDS.WIDTH')" v-model="varMaxW"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'date'">
                    <v-col cols="6" sm="6">
                      <v-menu
                        ref="minMenu"
                        v-model="minMenu"
                        :close-on-content-click="false"
                        :return-value.sync="minDate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.DATE.FIELDS.MIN_DATE')" v-model="minDate" readonly v-bind="attrs" v-on="on" clearable></v-text-field>
                        </template>
                        <v-date-picker v-model="minDate" no-title :locale="$t('GENERAL.LOCALE')">
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="secondary"
                            @click="minMenu = false"
                          >
                            {{ $t('GENERAL.BTNS.CANCEL') }}
                          </v-btn>
                          <v-btn
                            text
                            color="secondary"
                            @click="$refs.minMenu.save(minDate)"
                          >
                            {{ $t('GENERAL.BTNS.OK') }}
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6" sm="6">
                      <v-menu
                        ref="maxMenu"
                        v-model="maxMenu"
                        :close-on-content-click="false"
                        :return-value.sync="maxDate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.DATE.FIELDS.MAX_DATE')" v-model="maxDate" readonly v-bind="attrs" v-on="on" clearable></v-text-field>
                        </template>
                        <v-date-picker v-model="maxDate" no-title :locale="$t('GENERAL.LOCALE')">
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="secondary"
                            @click="maxMenu = false"
                          >
                            {{ $t('GENERAL.BTNS.CANCEL') }}
                          </v-btn>
                          <v-btn
                            text
                            color="secondary"
                            @click="$refs.maxMenu.save(maxDate)"
                          >
                            {{ $t('GENERAL.BTNS.OK') }}
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'time'">
                    <v-col cols="6" sm="6">
                      <v-menu
                        ref="minMenu"
                        v-model="minMenu"
                        :close-on-content-click="false"
                        :return-value.sync="minTime"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.TIME.FIELDS.MIN_TIME')" v-model="minTime" readonly v-bind="attrs" v-on="on" clearable></v-text-field>
                        </template>
                        <v-time-picker v-model="minTime" no-title format="24hr">
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="secondary"
                            @click="minMenu = false"
                          >
                            {{ $t('GENERAL.BTNS.CANCEL') }}
                          </v-btn>
                          <v-btn
                            text
                            color="secondary"
                            @click="$refs.minMenu.save(minTime)"
                          >
                            {{ $t('GENERAL.BTNS.OK') }}
                          </v-btn>
                        </v-time-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6" sm="6">
                      <v-menu
                        ref="maxMenu"
                        v-model="maxMenu"
                        :close-on-content-click="false"
                        :return-value.sync="maxTime"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.TIME.FIELDS.MAX_TIME')" v-model="maxTime" readonly v-bind="attrs" v-on="on" clearable></v-text-field>
                        </template>
                        <v-time-picker v-model="maxTime" no-title format="24hr">
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="secondary"
                            @click="maxMenu = false"
                          >
                            {{ $t('GENERAL.BTNS.CANCEL') }}
                          </v-btn>
                          <v-btn
                            text
                            color="secondary"
                            @click="$refs.maxMenu.save(maxTime)"
                          >
                            {{ $t('GENERAL.BTNS.OK') }}
                          </v-btn>
                        </v-time-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'time'">
                    <v-col cols="12" sm="12">
                      <v-switch color="success" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.TIME.FIELDS.FORMAT')" v-model="varIs24"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'text'">
                    <v-col cols="12" sm="12">
                      <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.DEFAULT_VAL')" v-model="varValue"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'text'">
                    <v-col cols="12" sm="12">
                      <v-switch color="success" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.TEXT.FIELDS.IS_EMAIL')" v-model="varIsEmail"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'textarea' || varType == 'number'">
                    <v-col cols="12" sm="12">
                      <v-textarea v-if="varType == 'textarea'" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.DEFAULT_VAL')" v-model="varValue"></v-textarea>
                      <v-text-field v-if="varType == 'number'" type="number" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.DEFAULT_VAL')" v-model="varValue"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'number'">
                    <v-col cols="12" sm="12">
                      <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.NUMBER.FIELDS.AUTO_CALC')" v-model="varAutocalc"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'subform'">
                    <v-col cols="12" sm="12">
                      <v-select :items="subformList" item-text="FORM_TITLE" item-value="FORM_KEY" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SUBFORM.FIELDS.FORM')" v-model="subform" :rules="[rules.requiredSelect]"></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'radio'">
                    <v-col cols="12" sm="12">
                      <v-data-table :headers="radioHeaders" :items="radioItems" item-key="id">
                        <template slot="top">
                          <v-toolbar
                            color="#2c3a47"
                            dark
                          >{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.RADIO.ADD_REMOVE') }}
                            <v-spacer></v-spacer>
                            <v-btn
                              small
                              class="mr-2"
                              color="success"
                              @click="addNewRow()"
                            ><v-icon medium>mdi-plus</v-icon></v-btn>
                          </v-toolbar>
                        </template>
                        <template slot="item.actions" slot-scope="row">
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="error"
                            @click="deleteRow(row.item.id)"
                          ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="warning"
                            @click="editRow(row.item.id)"
                          ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == radioItems.length - 1"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemDown(row.item.id, 'radioItems')"
                          ><v-icon medium>mdi-arrow-down-bold</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == 0"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemUp(row.item.id, 'radioItems')"
                          ><v-icon medium>mdi-arrow-up-bold</v-icon></v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'select' || varType == 'autocomplete'">
                    <v-col cols="12" sm="12">
                      <v-data-table :headers="selectHeaders" :items="selectItems" item-key="id">
                        <template slot="top">
                          <v-toolbar
                            color="#2c3a47"
                            dark
                          ><span v-if="varType == 'select'">{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.ADD_REMOVE') }}</span>
                           <span v-if="varType == 'autocomplete'">{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.AUTOCOMPLETE.ADD_REMOVE') }}</span>
                            <v-spacer></v-spacer>
                            <v-btn
                              small
                              class="mr-2"
                              color="success"
                              @click="addNewRow()"
                            ><v-icon medium>mdi-plus</v-icon></v-btn>
                          </v-toolbar>
                        </template>
                        <template slot="item.actions" slot-scope="row">
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="error"
                            @click="deleteRow(row.item.id)"
                          ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="warning"
                            @click="editRow(row.item.id)"
                          ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == selectItems.length - 1"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemDown(row.item.id, 'selectItems')"
                          ><v-icon medium>mdi-arrow-down-bold</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == 0"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemUp(row.item.id, 'selectItems')"
                          ><v-icon medium>mdi-arrow-up-bold</v-icon></v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'checkbox'">
                    <v-col cols="12" sm="12">
                      <v-data-table :headers="checkboxHeaders" :items="checkboxItems" item-key="id">
                        <template slot="top">
                          <v-toolbar
                            color="#2c3a47"
                            dark
                          >{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.ADD_REMOVE') }}
                            <v-spacer></v-spacer>
                            <v-btn
                              small
                              class="mr-2"
                              color="success"
                              @click="addNewRow()"
                            ><v-icon medium>mdi-plus</v-icon></v-btn>
                          </v-toolbar>
                        </template>
                        <template slot="item.isRequired" slot-scope="row">
                          <v-switch color="success" v-model="row.item.isRequired"></v-switch>
                        </template>
                        <template slot="item.isChecked" slot-scope="row">
                          <v-switch color="success" v-model="row.item.isChecked"></v-switch>
                        </template>
                        <template slot="item.actions" slot-scope="row">
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="error"
                            @click="deleteRow(row.item.id)"
                          ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="warning"
                            @click="editRow(row.item.id)"
                          ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == checkboxItems.length - 1"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemDown(row.item.id, 'checkboxItems')"
                          ><v-icon medium>mdi-arrow-down-bold</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == 0"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemUp(row.item.id, 'checkboxItems')"
                          ><v-icon medium>mdi-arrow-up-bold</v-icon></v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'combobox'">
                    <v-col cols="12" sm="12">
                      <v-data-table :headers="comboHeaders" :items="comboItems" item-key="id">
                        <template slot="top">
                          <v-toolbar
                            color="#2c3a47"
                            dark
                          >{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.COMBOBOX.ADD_REMOVE') }}
                            <v-spacer></v-spacer>
                            <v-btn
                              small
                              class="mr-2"
                              color="success"
                              @click="addNewRow()"
                            ><v-icon medium>mdi-plus</v-icon></v-btn>
                          </v-toolbar>
                        </template>
                        <template slot="item.actions" slot-scope="row">
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="error"
                            @click="deleteRow(row.item.id)"
                          ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="warning"
                            @click="editRow(row.item.id)"
                          ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == comboItems.length - 1"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemDown(row.item.id, 'comboItems')"
                          ><v-icon medium>mdi-arrow-down-bold</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == 0"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemUp(row.item.id, 'comboItems')"
                          ><v-icon medium>mdi-arrow-up-bold</v-icon></v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'array'">
                    <v-col cols="12" sm="12">
                      <v-data-table :headers="gridHeaders" :items="gridItems" item-key="id">
                        <template slot="top">
                          <v-toolbar
                            color="#2c3a47"
                            dark
                          >{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.GRID.ADD_REMOVE') }}
                            <v-spacer></v-spacer>
                            <v-btn
                              small
                              class="mr-2"
                              color="success"
                              @click="addNewRow()"
                            ><v-icon medium>mdi-plus</v-icon></v-btn>
                          </v-toolbar>
                        </template>
                        <template slot="item.actions" slot-scope="row">
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="error"
                            @click="deleteRow(row.item.id)"
                          ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="warning"
                            @click="editRow(row.item.id)"
                          ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == gridItems.length - 1"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemDown(row.item.id, 'gridItems')"
                          ><v-icon medium>mdi-arrow-down-bold</v-icon></v-btn>
                          <v-btn
                            :disabled="row.item.id == 0"
                            small
                            class="mr-2 float-right"
                            color="secondary"
                            @click="moveItemUp(row.item.id, 'gridItems')"
                          ><v-icon medium>mdi-arrow-up-bold</v-icon></v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'array'">
                    <v-col cols="6" sm="6">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.GRID.FIELDS.ALLOW_ADD')" color="success" v-model="allowAdd"></v-switch>
                    </v-col>
                    <v-col cols="6" sm="6">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.GRID.FIELDS.ALLOW_DELETE')" color="success" v-model="allowDelete"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType != 'group' && varType != 'page' && varType != 'title' && varType != 'subheader' && varType != 'subform' && varType != 'array' && varType != 'img' && varType != 'link'">
                    <v-col cols="12" sm="12">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.ENABLE_SQL')" color="warning" v-model="enableSql"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="enableSql">
                    <v-col cols="12" sm="12">
                      <v-select :items="allDbConns" item-text="name" item-value="val" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.AM_DATABASE')" v-model="fieldConnId"></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="enableSql">
                    <v-col cols="12" sm="12">
                      <v-text-field v-model="fieldSql" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.AM_SQL')"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'radio'">
                    <v-col cols="12" sm="12">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.RADIO.FIELDS.AS_ROW')" color="success" v-model="radioAsRow"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'select'">
                    <v-col cols="12" sm="12">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.FIELDS.IS_MULTI')" color="success" v-model="varAllowMultiple"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'file'">
                    <v-col cols="12" sm="12">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.FILE_UPLOADER.FIELDS.IS_MULTI')" color="success" v-model="varAllowMultiple"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType != 'group' && varType != 'page' && varType != 'title' && varType != 'subheader' && varType != 'para' && varType != 'link' && varType != 'img' && varType != 'subform' && varType != 'array'">
                    <v-col cols="12" sm="12">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.IS_REQUIRED')" color="success" v-model="varRequired"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType != 'group' && varType != 'page' && varType != 'title' && varType != 'para' && varType != 'subform'">
                    <v-col cols="12" sm="12">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.IS_HIDDEN')" color="success" v-model="varHidden"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType != 'group' && varType != 'page' && varType != 'title' && varType != 'subheader' && varType != 'para' && varType != 'link' && varType != 'img'">
                    <v-col cols="12" sm="12">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.IS_DISABLED')" color="success" v-model="varDisabled"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="varType == 'subform'">
                    <v-col cols="6" sm="6">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SUBFORM.FIELDS.SOLID_BORDER')" color="success" v-model="varBorderSolid"></v-switch>
                    </v-col>
                    <v-col cols="6" sm="6">
                      <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SUBFORM.FIELDS.DASHED_BORDER')" color="success" v-model="varBorderDashed"></v-switch>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  text
                  @click="cancelEditElement"
                >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="formAction != 'view'"
                  text
                  :disabled="!isFieldValid"
                  @click="verifyField({varType, varName, varLabel, minDate, maxDate, minTime, maxTime, varIs24, varValue, varIsEmail, varUrl, varMaxH, varMaxW, subform, varWidth, varOffset, varAutocalc, allowAdd, allowDelete, fieldConnId, fieldSql, radioAsRow, varAllowMultiple, varRequired, varHidden, varDisabled, varBorderSolid, varBorderDashed})"
                >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-tab-item>

      <!-- PREVIEW -->
      <v-tab-item class="grey lighten-2">
        <v-container fluid>
          <v-row>
            <v-col lg="8" cols="12" class="mx-auto my-8">

            <v-form v-if="formCount == 1 && formSchema !== null" lazy-validation @submit.prevent>
              <v-form-base :model="formModel" :schema="formSchema.forms[0]" />
              <div class="row custom-margin align-center justify-space-around">
                <v-btn
                  depressed
                  color="success"
                >
                  {{ $t('GENERAL.BTNS.SAVE') }}
                </v-btn>
                
                <v-btn
                  depressed
                  color="secondary"
                >
                  {{ $t('GENERAL.BTNS.SUBMIT') }}
                </v-btn>
              </div>
            </v-form>

            <v-stepper v-if="formCount > 1 && formSchema !== null" v-model="s1" class="bg-transparent overflow-visible" elevation="0" alt-labels>
              <v-stepper-items class="border-radius-xl overflow-hidden shadow-lg mt-8">
                <v-stepper-content 
                  v-for="form in formSchema.forms" :key="form.group0.step"
                  :step="form.group0.step"
                  class="bg-white border-radius-xl px-4 pt-4">
                  <v-form lazy-validation @submit.prevent>
                    <v-form-base :model="formModel" :schema="form" />
                    <v-card>
                      <div class="d-flex">
                        <v-btn
                          v-if="s1 <= formCount && s1 > 1"
                          :ripple="false"
                          :elevation="0"
                          class="
                              font-weight-bold
                              text-xs text-dark
                              btn-light
                              bg-gradient-light
                              py-5
                              px-6
                              mt-6
                              mb-2
                              ms-2
                            "
                          color="warning"
                          small
                          @click="s1 = s1 - 1"
                        >
                          {{ $t('GENERAL.BTNS.BACK') }}
                        </v-btn>
                        <v-spacer v-if="s1 <= formCount && s1 > 1"></v-spacer>
                        <v-btn 
                          :ripple="false"
                          :elevation="0"
                          class="
                            font-weight-bold
                            text-xs
                            btn-default
                            bg-gradient-success
                            py-5
                            px-6
                            mt-6
                            mb-2
                            me-2
                            ms-auto
                          "
                          color="success"
                          small>
                          {{ $t('GENERAL.BTNS.SAVE') }}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="s1 < formCount"
                          :ripple="false"
                          :elevation="0"
                          class="
                            font-weight-bold
                            text-xs
                            btn-default
                            bg-gradient-default
                            py-5
                            px-6
                            mt-6
                            mb-2
                            me-2
                            ms-auto
                          "
                          color="secondary"
                          @click="s1 = s1 + 1"
                        >
                          {{ $t('GENERAL.BTNS.CONTINUE') }}
                        </v-btn>

                        <v-btn
                          v-if="s1 == formCount"
                          :ripple="false"
                          :elevation="0"
                          class="
                            font-weight-bold
                            text-xs
                            btn-default
                            bg-gradient-default
                            py-5
                            px-6
                            mt-6
                            mb-2
                            me-2
                            ms-auto
                          "
                          color="secondary"
                        >
                          {{ $t('GENERAL.BTNS.SUBMIT') }}
                        </v-btn>
                      </div>
                    </v-card>
                  </v-form>
                </v-stepper-content>

              </v-stepper-items>
            </v-stepper>
              
            </v-col>
          </v-row>
        </v-container>

      </v-tab-item>
    </v-tabs-items>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="95%"
        v-model="jsDialog"
        :retain-focus="false"
        persistent
        content-class="js-dialog"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ $t('FORMS.NEW_EDIT_FORM.EDITOR.TITLE') }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ $t('FORMS.NEW_EDIT_FORM.EDITOR.DESC_1') }}</div>
            <div class="pt-0">{{ $t('FORMS.NEW_EDIT_FORM.EDITOR.DESC_2') }}</div>
            <div class="editor-wrapper">
              <code-mirror v-model="extScript" :extensions="extensions" />
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="closeJs()"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="formAction != 'view'"
              text
              @click="saveJs({extScript})"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="1200"
        v-model="queryDialog"
        :retain-focus="false"
        persistent
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ $t('FORMS.NEW_EDIT_FORM.QUERIES.TITLE') }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ $t('FORMS.NEW_EDIT_FORM.QUERIES.DESC') }}</div>
            <v-data-table :headers="queryHeaders" :items="queryItems" item-key="id">
              <template slot="top">
                <v-toolbar
                  color="#2c3a47"
                  dark
                >{{ $t('FORMS.NEW_EDIT_FORM.QUERIES.ADD_REMOVE') }}
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    class="mr-2"
                    color="success"
                    @click="addNewQuery()"
                  ><v-icon medium>mdi-plus</v-icon></v-btn>
                </v-toolbar>
              </template>
              <template slot="item.actions" slot-scope="row">
                <v-btn
                  small
                  class="mr-2 float-right"
                  color="error"
                  @click="deleteQuery(row.item.id)"
                ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                <v-btn
                  small
                  class="mr-2 float-right"
                  color="warning"
                  @click="editQuery(row)"
                ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                <v-btn
                  :disabled="row.item.id == queryItems.length - 1"
                  small
                  class="mr-2 float-right"
                  color="secondary"
                  @click="moveItemDown(row.item.id, 'queryItems')"
                ><v-icon medium>mdi-arrow-down-bold</v-icon></v-btn>
                <v-btn
                  :disabled="row.item.id == 0"
                  small
                  class="mr-2 float-right"
                  color="secondary"
                  @click="moveItemUp(row.item.id, 'queryItems')"
                ><v-icon medium>mdi-arrow-up-bold</v-icon></v-btn>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="queryDialog = false"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="700"
      v-model="addQueryDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ addQueryTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ addQueryText }}</div>
            <v-form v-model="isElementValid" ref="addQuery">
              <v-row>
                <v-col cols="12" sm="12">
                  <v-select
                    v-model="beforeAfter"
                    :label="$t('FORMS.NEW_EDIT_FORM.QUERIES.FIELDS.WHEN')"
                    :items="beforeAfterItems"
                    :rules="[rules.requiredSelect]"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-select
                    v-model="pageQueryNum"
                    :label="$t('FORMS.NEW_EDIT_FORM.QUERIES.FIELDS.PAGE')"
                    :items="pageQueryItems"
                    :rules="[rules.requiredSelect]"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-select
                    v-model="dbConnId"
                    :label="$t('FORMS.NEW_EDIT_FORM.QUERIES.ADD_EDIT_QUERY.FIELDS.DATABASE')"
                    :items="allDbConns"
                    item-text="name"
                    item-value="val"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="sqlQuery"
                    :label="$t('FORMS.NEW_EDIT_FORM.QUERIES.FIELDS.QUERY')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="sqlVar"
                    :label="$t('FORMS.NEW_EDIT_FORM.QUERIES.FIELDS.VARIABLE')"
                    :rules="[rules.noSpaces]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="sqlRunIf"
                    :label="$t('FORMS.NEW_EDIT_FORM.QUERIES.ADD_EDIT_QUERY.FIELDS.RUN_IF')"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelAddQuery()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isElementValid"
              @click="confirmAddQuery()"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="700"
      v-model="editQueryDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ editQueryTitle }}</v-toolbar>
          <v-card-text>
            <v-form v-model="isElementValid" ref="editQuery">
              <v-row>
                <v-col cols="12" sm="12">
                  <v-select
                    v-model="beforeAfter"
                    :label="$t('FORMS.NEW_EDIT_FORM.QUERIES.FIELDS.WHEN')"
                    :items="beforeAfterItems"
                    :rules="[rules.requiredSelect]"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-select
                    v-model="pageQueryNum"
                    :label="$t('FORMS.NEW_EDIT_FORM.QUERIES.FIELDS.PAGE')"
                    :items="pageQueryItems"
                    :rules="[rules.requiredSelect]"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-select
                    v-model="dbConnId"
                    :label="$t('FORMS.NEW_EDIT_FORM.QUERIES.ADD_EDIT_QUERY.FIELDS.DATABASE')"
                    :items="allDbConns"
                    item-text="name"
                    item-value="val"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="sqlQuery"
                    :label="$t('FORMS.NEW_EDIT_FORM.QUERIES.FIELDS.QUERY')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="sqlVar"
                    :label="$t('FORMS.NEW_EDIT_FORM.QUERIES.FIELDS.VARIABLE')"
                    :rules="[rules.noSpaces]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="sqlRunIf"
                    :label="$t('FORMS.NEW_EDIT_FORM.QUERIES.ADD_EDIT_QUERY.FIELDS.RUN_IF')"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelEditQuery()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isElementValid"
              @click="confirmEditQuery()"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="700"
      v-model="addRowDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ addRowTitle }}</v-toolbar>
          <v-card-text>
            <v-form v-model="isElementValid" ref="addRow">
              <v-row v-if="varType == 'array'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="itemValue"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.VAR_NAME')"
                    :rules="[rules.required, rules.noSpaces]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="varType == 'autocomplete' || varType == 'combobox' || varType == 'select'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="itemName"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.FIELDS.ITEM_NAME')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="varType != 'autocomplete' && varType != 'combobox' && varType != 'select' && varType != 'array'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="itemName"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.RADIO.FIELDS.LABEL')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="varType == 'array'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="itemName"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.GRID.FIELDS.FIELD_NAME')"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="varType == 'autocomplete' || varType == 'select'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="itemValue"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.FIELDS.ITEM_VAL')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="varType != 'autocomplete' && varType != 'combobox' && varType != 'select' && varType != 'array' && varType != 'checkbox'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="itemValue"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.RADIO.FIELDS.VALUE')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="varType == 'checkbox'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="itemValue"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.FIELDS.VARIABLE')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="varType == 'array'">
                <v-col cols="12" sm="12">
                  <v-select :items="gridFieldTypes" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.GRID.FIELDS.FIELD_TYPE')" item-text="name" item-value="val" v-model="itemType" :rules="[rules.requiredSelect]"></v-select>
                </v-col>
              </v-row>
              <v-row v-if="varType == 'checkbox' || varType == 'array'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    type="number"
                    v-model="itemWidth"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.FIELDS.WIDTH')"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'text'">
                <v-col cols="12" sm="12">
                  <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.DEFAULT_VAL')" v-model="configVarValue"></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'text'">
                <v-col cols="12" sm="12">
                  <v-switch color="success" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.TEXT.FIELDS.IS_EMAIL')" v-model="configVarIsEmail"></v-switch>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'textarea'">
                <v-col cols="12" sm="12">
                  <v-textarea :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.DEFAULT_VAL')" v-model="configVarValue"></v-textarea>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'number'">
                <v-col cols="12" sm="12">
                  <v-text-field type="number" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.DEFAULT_VAL')" v-model="configVarValue"></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'number'">
                <v-col cols="12" sm="12">
                  <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.NUMBER.FIELDS.AUTO_CALC')" v-model="configVarAutocalc"></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'select' || itemType == 'autocomplete'">
                <v-col cols="12" sm="12">
                  <v-data-table :headers="selectHeaders" :items="configSelectItems" item-key="id">
                    <template slot="top">
                      <v-toolbar
                        color="#2c3a47"
                        dark
                      ><span v-if="itemType == 'select'">{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.ADD_REMOVE') }}</span>
                       <span v-if="itemType == 'autocomplete'">{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.AUTOCOMPLETE.ADD_REMOVE') }}</span>
                        <v-spacer></v-spacer>
                        <v-btn
                          small
                          class="mr-2"
                          color="success"
                          @click="addConfigRow()"
                        ><v-icon medium>mdi-plus</v-icon></v-btn>
                      </v-toolbar>
                    </template>
                    <template slot="item.actions" slot-scope="row">
                      <v-btn
                        small
                        class="mr-2 float-right"
                        color="error"
                        @click="deleteConfigRow(row.item.id)"
                      ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                      <v-btn
                        small
                        class="mr-2 float-right"
                        color="warning"
                        @click="editConfigRow(row.item.id)"
                      ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                      <v-btn
                        :disabled="row.item.id == configSelectItems.length - 1"
                        small
                        class="mr-2 float-right"
                        color="secondary"
                        @click="moveItemDown(row.item.id, 'configSelectItems')"
                      ><v-icon medium>mdi-arrow-down-bold</v-icon></v-btn>
                      <v-btn
                        :disabled="row.item.id == 0"
                        small
                        class="mr-2 float-right"
                        color="secondary"
                        @click="moveItemUp(row.item.id, 'configSelectItems')"
                      ><v-icon medium>mdi-arrow-up-bold</v-icon></v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              
              <v-row v-if="itemType == 'combobox'">
                <v-col cols="12" sm="12">
                  <v-data-table :headers="comboHeaders" :items="configComboItems" item-key="id">
                    <template slot="top">
                      <v-toolbar
                        color="#2c3a47"
                        dark
                      >{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.COMBOBOX.ADD_REMOVE') }}
                        <v-spacer></v-spacer>
                        <v-btn
                          small
                          class="mr-2"
                          color="success"
                          @click="addConfigRow()"
                        ><v-icon medium>mdi-plus</v-icon></v-btn>
                      </v-toolbar>
                    </template>
                    <template slot="item.actions" slot-scope="row">
                      <v-btn
                        small
                        class="mr-2 float-right"
                        color="error"
                        @click="deleteConfigRow(row.item.id)"
                      ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                      <v-btn
                        small
                        class="mr-2 float-right"
                        color="warning"
                        @click="editConfigRow(row.item.id)"
                      ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                      <v-btn
                        :disabled="row.item.id == configComboItems.length - 1"
                        small
                        class="mr-2 float-right"
                        color="secondary"
                        @click="moveItemDown(row.item.id, 'configComboItems')"
                      ><v-icon medium>mdi-arrow-down-bold</v-icon></v-btn>
                      <v-btn
                        :disabled="row.item.id == 0"
                        small
                        class="mr-2 float-right"
                        color="secondary"
                        @click="moveItemUp(row.item.id, 'configComboItems')"
                      ><v-icon medium>mdi-arrow-up-bold</v-icon></v-btn>
                    </template>
                  </v-data-table> 
                </v-col>
              </v-row>
              <v-row v-if="varType == 'array'">
                <v-col cols="12" sm="12">
                  <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.ENABLE_SQL')" color="warning" v-model="configEnableSql"></v-switch>
                </v-col>
              </v-row>
              <v-row v-if="configEnableSql">
                <v-col cols="12" sm="12">
                  <v-select :items="allDbConns" item-text="name" item-value="val" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.AM_DATABASE')" v-model="configFieldConnId"></v-select>
                </v-col>
              </v-row>
              <v-row v-if="configEnableSql">
                <v-col cols="12" sm="12">
                  <v-text-field v-model="configFieldSql" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.AM_SQL')"></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'select'">
                <v-col cols="12" sm="12">
                  <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.FIELDS.IS_MULTI')" color="success" v-model="configVarAllowMultiple"></v-switch>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelAddRow()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isElementValid"
              @click="confirmAddRow()"
            >{{ $t('GENERAL.BTNS.ADD') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="700"
      v-model="editRowDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ editRowTitle }}</v-toolbar>
          <v-card-text>
            <v-form v-model="isElementValid" ref="editRow">
              <v-row v-if="varType == 'array'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="itemValue"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.VAR_NAME')"
                    :rules="[rules.required, rules.noSpaces]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="varType == 'autocomplete' || varType == 'combobox' || varType == 'select'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="itemName"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.FIELDS.ITEM_NAME')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="varType != 'autocomplete' && varType != 'combobox' && varType != 'select' && varType != 'array'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="itemName"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.RADIO.FIELDS.LABEL')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="varType == 'array'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="itemName"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.GRID.FIELDS.FIELD_NAME')"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="varType == 'autocomplete' || varType == 'select'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="itemValue"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.FIELDS.ITEM_VAL')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="varType != 'autocomplete' && varType != 'combobox' && varType != 'select' && varType != 'array' && varType != 'checkbox'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="itemValue"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.RADIO.FIELDS.VALUE')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="varType == 'checkbox'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="itemValue"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.FIELDS.VARIABLE')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="varType == 'array'">
                <v-col cols="12" sm="12">
                  <v-select :items="gridFieldTypes" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.GRID.FIELDS.FIELD_TYPE')" item-text="name" item-value="val" v-model="itemType" :rules="[rules.requiredSelect]"></v-select>
                </v-col>
              </v-row>
              <v-row v-if="varType == 'checkbox' || varType == 'array'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    type="number"
                    v-model="itemWidth"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.FIELDS.WIDTH')"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'text'">
                <v-col cols="12" sm="12">
                  <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.DEFAULT_VAL')" v-model="configVarValue"></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'text'">
                <v-col cols="12" sm="12">
                  <v-switch color="success" :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.TEXT.FIELDS.IS_EMAIL')" v-model="configVarIsEmail"></v-switch>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'textarea'">
                <v-col cols="12" sm="12">
                  <v-textarea :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.DEFAULT_VAL')" v-model="configVarValue"></v-textarea>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'number'">
                <v-col cols="12" sm="12">
                  <v-text-field type="number" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.DEFAULT_VAL')" v-model="configVarValue"></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'number'">
                <v-col cols="12" sm="12">
                  <v-text-field :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.NUMBER.FIELDS.AUTO_CALC')" v-model="configVarAutocalc"></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'select' || itemType == 'autocomplete'">
                <v-col cols="12" sm="12">
                  <v-data-table :headers="selectHeaders" :items="configSelectItems" item-key="id">
                    <template slot="top">
                      <v-toolbar
                        color="#2c3a47"
                        dark
                      ><span v-if="itemType == 'select'">{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.ADD_REMOVE') }}</span>
                       <span v-if="itemType == 'autocomplete'">{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.AUTOCOMPLETE.ADD_REMOVE') }}</span>
                        <v-spacer></v-spacer>
                        <v-btn
                          small
                          class="mr-2"
                          color="success"
                          @click="addConfigRow()"
                        ><v-icon medium>mdi-plus</v-icon></v-btn>
                      </v-toolbar>
                    </template>
                    <template slot="item.actions" slot-scope="row">
                      <v-btn
                        small
                        class="mr-2 float-right"
                        color="error"
                        @click="deleteConfigRow(row.item.id)"
                      ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                      <v-btn
                        small
                        class="mr-2 float-right"
                        color="warning"
                        @click="editConfigRow(row.item.id)"
                      ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                      <v-btn
                        :disabled="row.item.id == configSelectItems.length - 1"
                        small
                        class="mr-2 float-right"
                        color="secondary"
                        @click="moveItemDown(row.item.id, 'configSelectItems')"
                      ><v-icon medium>mdi-arrow-down-bold</v-icon></v-btn>
                      <v-btn
                        :disabled="row.item.id == 0"
                        small
                        class="mr-2 float-right"
                        color="secondary"
                        @click="moveItemUp(row.item.id, 'configSelectItems')"
                      ><v-icon medium>mdi-arrow-up-bold</v-icon></v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              
              <v-row v-if="itemType == 'combobox'">
                <v-col cols="12" sm="12">
                  <v-data-table :headers="comboHeaders" :items="configComboItems" item-key="id">
                    <template slot="top">
                      <v-toolbar
                        color="#2c3a47"
                        dark
                      >{{ $t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.COMBOBOX.ADD_REMOVE') }}
                        <v-spacer></v-spacer>
                        <v-btn
                          small
                          class="mr-2"
                          color="success"
                          @click="addConfigRow()"
                        ><v-icon medium>mdi-plus</v-icon></v-btn>
                      </v-toolbar>
                    </template>
                    <template slot="item.actions" slot-scope="row">
                      <v-btn
                        small
                        class="mr-2 float-right"
                        color="error"
                        @click="deleteConfigRow(row.item.id)"
                      ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                      <v-btn
                        small
                        class="mr-2 float-right"
                        color="warning"
                        @click="editConfigRow(row.item.id)"
                      ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                      <v-btn
                        :disabled="row.item.id == configComboItems.length - 1"
                        small
                        class="mr-2 float-right"
                        color="secondary"
                        @click="moveItemDown(row.item.id, 'configComboItems')"
                      ><v-icon medium>mdi-arrow-down-bold</v-icon></v-btn>
                      <v-btn
                        :disabled="row.item.id == 0"
                        small
                        class="mr-2 float-right"
                        color="secondary"
                        @click="moveItemUp(row.item.id, 'configComboItems')"
                      ><v-icon medium>mdi-arrow-up-bold</v-icon></v-btn>
                    </template>
                  </v-data-table> 
                </v-col>
              </v-row>
              <v-row v-if="varType == 'array'">
                <v-col cols="12" sm="12">
                  <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.ENABLE_SQL')" color="warning" v-model="configEnableSql"></v-switch>
                </v-col>
              </v-row>
              <v-row v-if="configEnableSql">
                <v-col cols="12" sm="12">
                  <v-select :items="allDbConns" item-text="name" item-value="val" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.AM_DATABASE')" v-model="configFieldConnId"></v-select>
                </v-col>
              </v-row>
              <v-row v-if="configEnableSql">
                <v-col cols="12" sm="12">
                  <v-text-field v-model="configFieldSql" :label="$t('FORMS.NEW_EDIT_FORM.FIELDS.AM_SQL')"></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'select'">
                <v-col cols="12" sm="12">
                  <v-switch :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.FIELDS.IS_MULTI')" color="success" v-model="configVarAllowMultiple"></v-switch>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelEditRow()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isElementValid"
              @click="confirmEditRow()"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="500"
      v-model="addConfigRowDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ addConfigRowTitle }}</v-toolbar>
          <v-card-text>
            <v-form v-model="isConfigElementValid" ref="addConfigRow">
              <v-row v-if="itemType == 'autocomplete' || itemType == 'combobox' || itemType == 'select'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="configItemName"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.FIELDS.ITEM_NAME')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType != 'autocomplete' && itemType != 'combobox' && itemType != 'select'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="configItemName"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.RADIO.FIELDS.LABEL')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'autocomplete' || itemType == 'select'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="configItemValue"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.FIELDS.ITEM_VAL')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType != 'autocomplete' && itemType != 'combobox' && itemType != 'select'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="configItemValue"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.RADIO.FIELDS.VALUE')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'checkbox'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    type="number"
                    v-model="configItemWidth"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.FIELDS.WIDTH')"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelAddConfigRow()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isConfigElementValid"
              @click="confirmAddConfigRow()"
            >{{ $t('GENERAL.BTNS.ADD') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="500"
      v-model="editConfigRowDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ editConfigRowTitle }}</v-toolbar>
          <v-card-text>
            <v-form v-model="isConfigElementValid" ref="editConfigRow">
              <v-row v-if="itemType == 'autocomplete' || itemType == 'combobox' || itemType == 'select'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="configItemName"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.FIELDS.ITEM_NAME')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType != 'autocomplete' && itemType != 'combobox' && itemType != 'select'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="configItemName"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.RADIO.FIELDS.LABEL')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'autocomplete' || itemType == 'select'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="configItemValue"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.FIELDS.ITEM_VAL')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType != 'autocomplete' && itemType != 'combobox' && itemType != 'select'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="configItemValue"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.RADIO.FIELDS.VALUE')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="itemType == 'checkbox'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    type="number"
                    v-model="configItemWidth"
                    :label="$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.FIELDS.WIDTH')"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelEditConfigRow()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isConfigElementValid"
              @click="confirmEditConfigRow()"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="resetFormDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ resetFormTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ resetFormText }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="resetFormDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmResetForm()"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      v-model="saveCloseDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ $t('FORMS.NEW_EDIT_FORM.SAVE_FORM.TITLE') }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ $t('FORMS.NEW_EDIT_FORM.SAVE_FORM.DESC') }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="confirmClose('no')"
            >{{ $t('FORMS.NEW_EDIT_FORM.SAVE_FORM.BTNS.CLOSE') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmClose('save')"
            >{{ $t('FORMS.NEW_EDIT_FORM.SAVE_FORM.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
  
</template>

<script>
  import CodeMirror from 'vue-codemirror6';
  import { basicSetup } from '@codemirror/basic-setup';
  import { EditorView, keymap } from '@codemirror/view';
  import { indentWithTab } from '@codemirror/commands';
  import { oneDark } from '@codemirror/theme-one-dark';
  import { javascript } from '@codemirror/lang-javascript';
  import { syntaxTree } from '@codemirror/language';
  import { autocompletion } from '@codemirror/autocomplete';

  const completePropertyAfter = ["PropertyName", ".", "?."]
  const dontCompleteIn = ["TemplateString", "LineComment", "BlockComment",
                        "VariableDefinition", "PropertyDefinition"]

  import { mapGetters } from 'vuex';
  import VueGridLayout from 'vue-grid-layout';
  import VFormBase from 'vuetify-form-base';
    
  let mouseXY = {"x": null, "y": null};
  let DragPos = {"x": null, "y": null, "w": 1, "h": 1, "i": null};
  export default {
    name: 'buildform',
    computed: {
      ...mapGetters(['formId', 'formAction', 'savedGridLayout', 'subformList', 'subformSchema', 'allProcessXml', 'allDocTemplates', 'processVars', 'sqlQueries', 'allForms', 'exportedForm', 'allExtDbs', 'errorMessage']),
      versionFilter(){
        return this.allProcessXml.filter(item => item.PROCESS_KEY === this.processKey)
      },
      varFilter(){
        let options = this.availableVars.filter(item => item.varType === this.varType);
        let varNames = [];

        for(let i = 0; i < options.length; i++) {
          varNames.push(options[i].varName);
        }
        return varNames;
      }
    },
    components: {
        GridLayout: VueGridLayout.GridLayout,
        GridItem: VueGridLayout.GridItem,
        VFormBase,
        CodeMirror,
    },
    data: function() {
      return {
        addBtn: false,
        isFormValid: false,
        isElementValid: false,
        isConfigElementValid: false,
        isFieldValid: false,
        rules: {
          required: value => !!value || 'Required',
          requiredSelect: value => {
            let res = !!value || "Required";
            return res;
          },
          noSpaces: value => (value || '').indexOf(' ') < 0 || 'No spaces are allowed'
        },
        option: null,
        processKey: '',
        processVersion: null,
        formKey: '',
        originalKey: '',
        extScript: '',
        lastScript: '',
        resetFormDialog: false,
        resetFormTitle: null,
        resetFormText: null,
        jsDialog: false,
        pdfDialog: false,
        pdfTemplateId: null,
        s1: 1,
        tab: null,
        layout: [],
        formModel: [],
        formSchema: null,
        formCount: 1,
        formTitle: '',
        formExists: false,
        availableVars: [],
        currentEvt: null,
        currentElementId: null,
        newElementDialog: false,
        newElementTitle: null,
        newElementText: null,
        editElementDialog: false,
        editElementTitle: null,
        editElementText: null,
        saveCloseDialog: false,
        varAction: null,
        varType: null,
        varName: '',
        varLabel: '',
        varValue: null,
        varIsEmail: false,
        varUrl: null,
        varMaxH: null,
        varMaxW: null,
        varWidth: 3,
        varOffset: 0,
        varAutocalc: null,
        varAllowMultiple: false,
        varRequired: false,
        varHidden: false,
        varDisabled: false,
        varBorderSolid: false,
        varBorderDashed: false,
        radioAsRow: true,
        fieldSql: null,
        fieldConnId: 0,
        enableSql: false,
        subheaders: 0,
        subs: [],
        paragraphs: 0,
        paras: [],
        groups: 1,
        isMulti: 0,
        isLocked: 1,
        lockedBy: '',
        subform: null,
        tempSchema: {},
        minMenu: false,
        maxMenu: false,
        minDate: null,
        maxDate: null,
        minTime: null,
        maxTime: null,
        varIs24: true,
        radioHeaders: [
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.RADIO.FIELDS.LABEL'), align: 'start', value: 'label', sortable: false },
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.RADIO.FIELDS.VALUE'), value: 'value', sortable: false },
          { text: '', value: 'actions', sortable: false }
        ],
        radioItems: [],
        selectHeaders: [
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.FIELDS.ITEM_NAME'), align: 'start', value: 'itemText', sortable: false },
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.FIELDS.ITEM_VAL'), value: 'itemValue', sortable: false },
          { text: '', value: 'actions', sortable: false }
        ],
        selectItems: [],
        configSelectItems: [],
        checkboxHeaders: [
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.FIELDS.LABEL'), align: 'start', value: 'label', sortable: false },
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.FIELDS.VARIABLE'), value: 'variableName', sortable: false },
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.FIELDS.WIDTH'), value: 'width', sortable: false },
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.FIELDS.CHECKED'), value: 'isChecked', sortable: false },
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.FIELDS.REQUIRED'), value: 'isRequired', sortable: false },
          { text: '', value: 'actions', sortable: false }
        ],
        checkboxItems: [],
        configCheckboxHeaders: [
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.FIELDS.LABEL'), align: 'start', value: 'label', sortable: false },
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.FIELDS.VARIABLE'), value: 'variableName', sortable: false },
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.FIELDS.WIDTH'), value: 'width', sortable: false },
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.FIELDS.CHECKED'), value: 'isChecked', sortable: false },
          { text: '', value: 'actions', sortable: false }
        ],
        configCheckboxItems: [],
        comboHeaders: [
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.COMBOBOX.FIELDS.ITEM_NAME'), align: 'start', value: 'itemName', sortable: false },
          { text: '', value: 'actions', sortable: false }
        ],
        comboItems: [],
        configComboItems: [],
        gridHeaders: [
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELDS.VAR_NAME'), align: 'start', value: 'fieldVarName', sortable: false },
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.GRID.FIELDS.FIELD_NAME'), value: 'fieldName', sortable: false },
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.GRID.FIELDS.FIELD_TYPE'), value: 'fieldType', sortable: false },
          { text: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.GRID.FIELDS.WIDTH'), value: 'fieldWidth', sortable: false },
          { text: '', value: 'actions', sortable: false }
        ],
        gridItems: [],
        gridFieldTypes: [
          { name: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.TEXT.LABEL'), val: 'text' },
          { name: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.TEXTAREA.LABEL'), val: 'textarea' },
          { name: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.NUMBER.LABEL'), val: 'number' },
          { name: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.SELECT.LABEL'), val: 'select' },
          { name: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.AUTOCOMPLETE.LABEL'), val: 'autocomplete' },
          { name: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.COMBOBOX.LABEL'), val: 'combobox' },
          { name: this.$t('FORMS.NEW_EDIT_FORM.FIELD_TYPES.CHECKBOX.LABEL'), val: 'checkbox' }
        ],
        allowAdd: true,
        allowDelete: true,
        addRowDialog: false,
        addRowTitle: '',
        editRowDialog: false,
        editRowTitle: '',
        rowIndex: null,
        itemName: '',
        itemValue: '',
        itemType: '',
        itemWidth: 2,
        addConfigRowDialog: false,
        addConfigRowTitle: '',
        editConfigRowDialog: false,
        editConfigRowTitle: '',
        configRowIndex: null,
        configItemName: '',
        configItemValue: '',
        configItemWidth: 2,
        configVarValue: null, 
        configVarIsEmail: null, 
        configVarAutocalc: null, 
        configEnableSql: false,
        configFieldConnId: 0,
        configFieldSql: null, 
        configVarAllowMultiple: null,
        queryDialog: false,
        addQueryDialog: false,
        addQueryTitle: '',
        addQueryText: '',
        editQueryDialog: false,
        editQueryTitle: '',
        editQueryId: null,
        pageQueryNum: null,
        sqlQuery: '',
        sqlVar: '',
        sqlRunIf: '',
        pageQueryItems: [],
        queryHeaders: [
          { text: this.$t('FORMS.NEW_EDIT_FORM.QUERIES.FIELDS.WHEN'), value: 'beforeAfter', sortable: false },
          { text: this.$t('FORMS.NEW_EDIT_FORM.QUERIES.FIELDS.PAGE'), value: 'pageQueryNum', sortable: false },
          { text: this.$t('FORMS.NEW_EDIT_FORM.QUERIES.FIELDS.QUERY'), value: 'sqlQuery', sortable: false },
          { text: this.$t('FORMS.NEW_EDIT_FORM.QUERIES.FIELDS.VARIABLE'), value: 'sqlVar', sortable: false },
          { text: this.$t('FORMS.NEW_EDIT_FORM.QUERIES.FIELDS.RUN_IF'), value: 'sqlRunIf', sortable: false },
          { text: '', value: 'actions', sortable: false, width: 300 }
        ],
        queryItems: [],
        beforeAfter: null,
        beforeAfterItems: [this.$t('FORMS.NEW_EDIT_FORM.QUERIES.FIELDS.BEFORE'), this.$t('FORMS.NEW_EDIT_FORM.QUERIES.FIELDS.AFTER')],
        dbConnId: 0,
        allDbConns: [],
        snack: false,
        snackColor: '',
        snackText: '',
        allOk: true,
        editorState: null,
        editorView: null,
        editorChange: false,
        extensions: [
          basicSetup,
          oneDark,
          keymap.of([indentWithTab]),
          javascript(),
          autocompletion({override: [this.completeFromGlobalScope]}),
          EditorView.updateListener.of((v) => {
            this.editorState = v.state;
            this.editorView = v.view;

            if(v.docChanged) {
              this.editorChange = true;
            }
          })
        ],
        defaultScript: '// Code to run only once as the form loads\nif(runOnce){\n\n\n\n}\n\n' + 
          '// Code to run on the first page\nif(continueClicked && currentPage == 1){\n\n\n\n}\n\n' + 
          '// Code to run on the second page\nif(continueClicked && currentPage == 2){\n\n\n\n}\n\n' + 
          '// Code to run after submit is clicked\nif(submitting){\n\n\n\n}'
      }
    },
    async created() {
      this.$store.dispatch('getAllProcessXml');

      this.unsubscribe = this.$store.subscribe((mutation) => {

        if(mutation.type === 'ERROR_MESSAGE') {
          this.snackErrorMessage();
        }

        if(mutation.type === 'PREVIEW_LOADED') {
          this.formCount = this.formSchema.forms.length;
          setTimeout(this.setStyle, 100);
          setTimeout(this.populateSubheaders, 500);
        }

      });

      if(this.formAction == 'edit' || this.formAction == 'view') {
        this.lockedBy = this.$store.state.currentUser;
        let data = {
          'formAction': this.formAction,
          'lockedBy': this.lockedBy,
          'formKey': this.$store.getters.formKey,
          'processKey': this.$store.getters.processKey,
          'processVersion': this.$store.getters.processVersion
        }

        await this.$store.dispatch('getForm', data).then( () => {
          this.formKey = this.$store.getters.formKey;
          this.processKey = this.$store.getters.processKey;
          this.processVersion = this.$store.getters.processVersion;
          this.formTitle = this.$store.getters.formTitle;
          this.layout = this.savedGridLayout;
          this.originalKey = this.formKey;

          // Prepare script
          this.extScript = this.$store.getters.extScript;
          
          this.buildSchema('initial').then( () => {
            this.formCount = this.formSchema.forms.length;
          });
          
          // Set the grid order of all items
          if(this.sqlQueries != null) {
            this.queryItems = this.sqlQueries;
            this.reorderItems('queryItems');
          }

          if(this.configSelectItems != null) {
            this.reorderItems('configSelectItems');
          }
          if(this.configCheckboxItems != null) {
            this.reorderItems('configCheckboxItems');
          }
          if(this.configComboItems != null) {
            this.reorderItems('configComboItems');
          }
          if(this.gridItems != null) {
            this.reorderItems('gridItems');
          }
          if(this.comboItems != null) {
            this.reorderItems('comboItems');
          }
          if(this.checkboxItems != null) {
            this.reorderItems('checkboxItems');
          }
          if(this.selectItems != null) {
            this.reorderItems('selectItems');
          }
          if(this.radioItems != null) {
            this.reorderItems('radioItems');
          }

          if(this.formAction == 'edit') {
            this.$store.dispatch('getProcessVars', this.processKey).then( () => {
              this.availableVars = this.processVars;
            });
          }
        });
      }else {
        this.extScript = this.defaultScript;
      }

      this.lastScript = this.extScript;

      // Get subform list
      this.$store.dispatch('getSubFormList');

      // Get all available DB connections
      this.getAllDbConns();
    },
    mounted() {
      document.addEventListener("dragover", function (e) {
        mouseXY.x = e.clientX;
        mouseXY.y = e.clientY;
      }, false);
    },
    beforeDestroy() {
      this.unsubscribe();
    },
    methods: {
      completeFromGlobalScope(context) {
        let nodeBefore = syntaxTree(context.state).resolveInner(context.pos, -1)
        if (completePropertyAfter.includes(nodeBefore.name) &&
            nodeBefore.parent?.name == "MemberExpression") {
          let object = nodeBefore.parent.getChild("Expression")
          if (object?.name == "VariableName") {
            let from = /\./.test(nodeBefore.name) ? nodeBefore.to : nodeBefore.from
            let variableName = context.state.sliceDoc(object.from, object.to)
            if (typeof window[variableName] == "object")
              return this.completeProperties(from, window[variableName])
          }
        } else if (nodeBefore.name == "VariableName") {
          return this.completeProperties(nodeBefore.from, window)
        } else if (context.explicit && !dontCompleteIn.includes(nodeBefore.name)) {
          return this.completeProperties(context.pos, window)
        }
        return null
      },
      completeProperties(from, object) {
        let options = []
        for (let name in object) {
          options.push({
            label: name,
            type: typeof object[name] == "function" ? "function" : "variable"
          })
        }
        return {
          from,
          options,
          validFor: /^[\w$]*$/
        }
      },
      getAllDbConns() {
        this.$store.dispatch('getAllConnections').then( () => {
          this.allDbConns.push({ name: 'Harlequin', val: 0 });

          for(let i = 0; i < this.allExtDbs.length; i++) {
            this.allDbConns.push({ name: this.allExtDbs[i].DB_NAME, val: this.allExtDbs[i].ID });
          }
        });
      },
      populateSubheaders() {
        // Populate subheader, title and paragraph text
        for(let s = 0; s < this.subs.length; s++) {
          document.getElementById(this.subs[s].id).innerHTML = this.subs[s].text;
        }
        this.subs = [];

        for(let p = 0; p < this.paras.length; p++) {
          document.getElementById(this.paras[p].id).innerHTML = this.paras[p].text;
        }
        this.paras = [];
      },
      setStyle() {
        // Add negative tabindex to icons
        let icons = document.querySelectorAll('.v-icon');
        for(let v = 0; v < icons.length; v++) {
          icons[v].setAttribute('tabindex', -1);
        }

        // Add colour class to v-cards
        let cards = document.getElementsByClassName('v-card');
        
        for(let c = 0; c < cards.length; c++) {
          cards[c].classList.add('grey', 'lighten-2');
        }

        // Add background to inputs
        let inputs = document.getElementsByClassName('v-input__slot');
        
        for(let p = 0; p < inputs.length; p++) {
          inputs[p].setAttribute('style', 'background-color: white; border-radius: 5px; padding: 10px;');
        }

        // Remove attributes for subforms if border is set
        let solidBorders = document.getElementsByClassName('subform-border-solid');
        
        for(let sb = 0; sb < solidBorders.length; sb++) {
          solidBorders[sb].classList.remove('grey', 'lighten-2');
        }

        let dashedBorders = document.getElementsByClassName('subform-border-dashed');
        
        for(let db = 0; db < dashedBorders.length; db++) {
          dashedBorders[db].classList.remove('grey', 'lighten-2');
        }
      },
      resetStyle() {
        // Add negative tabindex to icons
        let icons = document.querySelectorAll('.v-icon');
        for(let v = 0; v < icons.length; v++) {
          icons[v].setAttribute('tabindex', -1);
        }
        
        // Add colour class to v-cards
        let cards = document.getElementsByClassName('v-card');
        
        for(let c = 0; c < cards.length; c++) {
          cards[c].classList.remove('grey', 'lighten-2');
        }

        // Add background to inputs
        let inputs = document.getElementsByClassName('v-input__slot');
        
        for(let p = 0; p < inputs.length; p++) {
          inputs[p].setAttribute('style', '');
        }
        
        // Remove attributes for subforms if border is set
        let solidBorders = document.getElementsByClassName('subform-border-solid');
        
        for(let sb = 0; sb < solidBorders.length; sb++) {
          solidBorders[sb].classList.remove('grey', 'lighten-2');
        }

        let dashedBorders = document.getElementsByClassName('subform-border-dashed');
        
        for(let db = 0; db < dashedBorders.length; db++) {
          dashedBorders[db].classList.remove('grey', 'lighten-2');
        }
      },
      setTabs() {
        // Add negative tabindex to icons
        let icons = document.querySelectorAll('.v-icon');
        for(let v = 0; v < icons.length; v++) {
          icons[v].setAttribute('tabindex', -1);
        }
      },
      closeForm(action) {
        this.isLocked = 0;
        this.lockedBy = '';
        if(action == 'view') {
          this.$router.push({ name: 'FormBuilder' });
        }else {
          this.saveCloseDialog = true;
        }
      },
      confirmClose(action) {
        this.saveCloseDialog = false;
        if(action == 'save') {
          this.buildSchema('save').then( () => {
            if(!this.formExists) {
              let payload = {
                'formId': this.formId,
                'checkType': 'unlock'
              };
              this.$store.dispatch('lockCheck', payload).then( () => {
                this.$store.commit('EDITING_FORM', false);
                this.$router.push({ name: 'FormBuilder' });
              });
            }
          });
        }else {
          let payload = {
            'formId': this.formId,
            'checkType': 'unlock'
          };
          this.$store.dispatch('lockCheck', payload).then( () => {
            this.$store.commit('EDITING_FORM', false);
            this.$router.push({ name: 'FormBuilder' });
          });
        }
      },
      loadProcessVars() {
        this.$store.dispatch('getProcessVars', this.processKey).then( () => {
          this.availableVars = this.processVars;
        });
      },
      async formExistsCheck() {
        let exists = false;
        
        for(let i =0; i < this.allForms.length; i++) {
          if(this.allForms[i].FORM_KEY == this.formKey && this.originalKey != this.formKey) {
            exists = true;
            break;
          }
        }
        this.formExists = exists;
      },
      saveForm(vars) {
        // Set the form key based off form title
        // this.formKey = this.formTitle.replace(/[&/\\#,+()$~%.'":*?<>{}]/g, ''); // Remove specials
        // this.formKey = this.formKey.replace(/\s/g, ''); // Remove spaces
        // this.formKey += this.processVersion;

        if(this.formAction == 'new') {
          // Set new form ID
          let chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
          this.formKey = 'Form_';

          // Generate ID
          for (let j = 0; j < 7; j++) {
              this.formKey += chars.charAt(Math.floor(Math.random() * chars.length));
          }
        }

        this.formExistsCheck().then( () => {
          if(this.formExists) {
            this.snackExists();
          }else {
            let jScript = [];
            jScript.push({ theScript: this.extScript });
            
            let payload = {
              'processKey': this.processKey,
              'processVersion': parseInt(this.processVersion),
              'formKey': this.formKey,
              'schema': JSON.stringify(this.formSchema),
              'formTitle': this.formTitle,
              'gridLayout': JSON.stringify(this.layout),
              'extScript': JSON.stringify(jScript),
              'formAction': this.formAction,
              'formId': this.formId,
              'isMulti': this.isMulti,
              'sqlQueries': JSON.stringify(this.queryItems),
              'isDeployed': 0,
              'isLocked': this.isLocked,
              'lockedBy': this.lockedBy,
              'processVars': JSON.stringify(vars)
            };
            
            this.$store.dispatch('uploadForm', payload).then( () => {
              this.snackSave();
              if(this.formAction == 'new') {
                this.$store.commit('UPDATE_FORM_ACTION', 'edit');
                this.updateLog('Form', 'Created', 'Form ' + this.formTitle + ' created.');
              }else {
                this.updateLog('Form', 'Updated', 'Form ' + this.formTitle + ' updated.');
              }
            });
          }
        });
      },
      resetForm() {
        this.resetFormTitle = this.$t('FORMS.NEW_EDIT_FORM.RESET_FORM.TITLE');
        this.resetFormText = this.$t('FORMS.NEW_EDIT_FORM.RESET_FORM.DESC');
        this.resetFormDialog = true;
      },
      confirmResetForm() {
        this.resetFormDialog = false;
        this.layout = [];
        this.formModel = [];
        this.formTitle = '',
        this.formCount = 1;
        this.isMulti = 0;
        this.queryItems = [];
        this.extScript = this.defaultScript;
        this.lastScript = this.extScript;
        this.resetEditor();
        this.resetDefaults();
      },
      resetDefaults() {
        this.currentEvt = null;
        this.currentElementId = null;
        this.varAction = null;
        this.varType = null;
        this.varName = '';
        this.varLabel = '';
        this.varValue = null;
        this.varIsEmail = false;
        this.varUrl = null;
        this.varMaxH = null;
        this.varMaxW = null;
        this.varWidth = 3;
        this.varOffset = 0;
        this.varAutocalc = null;
        this.varAllowMultiple = false;
        this.varRequired = false;
        this.varHidden = false;
        this.varDisabled = false;
        this.varBorderSolid = false;
        this.varBorderDashed = false;
        this.radioAsRow = true;
        this.enableSql = false;
        this.fieldSql = null;
        this.fieldConnId = 0;
        this.radioItems = [];
        this.selectItems = [];
        this.configSelectItems = [];
        this.checkboxItems = [];
        this.configCheckboxItems = [];
        this.comboItems = [];
        this.configComboItems = [];
        this.gridItems = [];
        this.allowAdd = true;
        this.allowDelete = true;
        this.minMenu = false;
        this.maxMenu = false;
        this.minDate = null;
        this.maxDate = null;
        this.minTime = null;
        this.maxTime = null;
        this.varIs24 = true;
        this.subform = null;
        this.pdfTemplateId = null;
        this.editQueryId = null;
        this.pageQueryNum = null;
        this.dbConnId = 0;
        this.sqlQuery = '';
        this.sqlVar = '';
        this.sqlRunIf = '';
        this.beforeAfter = null;
        this.rowIndex = null;
        this.configRowIndex = null;
        this.configItemName = '';
        this.configItemValue = '';
        this.configItemWidth = 2;
        this.configVarValue = null; 
        this.configVarIsEmail = null; 
        this.configVarAutocalc = null; 
        this.configEnableSql = false;
        this.configFieldConnId = 0;
        this.configFieldSql = null;
        this.configVarAllowMultiple = null;
      },
      async exportForm() {
        let payload = {
          'formId': this.formId,
          'formTitle': this.formTitle
        };
        await this.$store.dispatch('exportForm', payload).then( () => {
          let e = document.createEvent('MouseEvents');
          let a = document.createElement('a');

          a.download = this.exportedForm[0].fileName;
          a.href = this.exportedForm[0].fileData;
          e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          a.dispatchEvent(e);
        });
      },
      verifyField(item) {
        let isError = false

        if(item.varType != 'group' && item.varType != 'page' && item.varType != 'title' && item.varType != 'subheader' && item.varType != 'para' && item.varType != 'subform') {
          for(let j = 0; j < this.layout.length; j++) {
            if(this.layout[j].data.varName == item.varName && this.layout[j].i != this.currentElementId) {
              isError = true;
            }
          }
        }

        if(isError) {
          this.snackError();
        }else {
          this.updateElement(item);
        }
      },
      getPages() {
        let numOfPages = this.formCount;
        for(let i = 1; i <= numOfPages; i++) {
          this.pageQueryItems.push(i);
        }
      },
      addNewQuery() {
        this.addQueryTitle = this.$t('FORMS.NEW_EDIT_FORM.QUERIES.ADD_EDIT_QUERY.ADD_TITLE');
        this.addQueryText = this.$t('FORMS.NEW_EDIT_FORM.QUERIES.ADD_EDIT_QUERY.ADD_DESC');
        this.getPages();
        this.addQueryDialog = true;
        this.setTabs();
      },
      confirmAddQuery() {
        this.addQueryDialog = false;
        this.queryItems.push({ beforeAfter: this.beforeAfter, pageQueryNum: this.pageQueryNum, dbConnId: this.dbConnId, sqlQuery: this.sqlQuery, sqlVar: this.sqlVar, sqlRunIf: this.sqlRunIf });
        this.reorderItems('queryItems');

        this.beforeAfter = null;
        this.pageQueryNum = null;
        this.dbConnId = 0;
        this.sqlQuery = '';
        this.sqlVar = '';
        this.sqlRunIf = '';
        this.$refs.addQuery.resetValidation();
      },
      cancelAddQuery() {
        this.addQueryDialog = false;
        this.beforeAfter = null;
        this.pageQueryNum = null;
        this.dbConnId = 0;
        this.sqlQuery = '';
        this.sqlVar = '';
        this.sqlRunIf = '';
        this.$refs.addQuery.resetValidation();
      },
      editQuery(query) {
        this.editQueryTitle = this.$t('FORMS.NEW_EDIT_FORM.QUERIES.ADD_EDIT_QUERY.EDIT_TITLE');
        this.beforeAfter = query.item.beforeAfter;
        this.pageQueryNum = query.item.pageQueryNum;
        this.dbConnId = query.item.dbConnId;
        this.sqlQuery = query.item.sqlQuery;
        this.sqlVar = query.item.sqlVar;
        this.sqlRunIf = query.item.sqlRunIf;
        this.editQueryId = query.item.id;
        this.getPages();
        this.editQueryDialog = true;
      },
      confirmEditQuery() {
        this.editQueryDialog = false;
        this.queryItems[this.editQueryId].beforeAfter = this.beforeAfter;
        this.queryItems[this.editQueryId].pageQueryNum = this.pageQueryNum;
        this.queryItems[this.editQueryId].dbConnId = this.dbConnId;
        this.queryItems[this.editQueryId].sqlQuery = this.sqlQuery;
        this.queryItems[this.editQueryId].sqlVar = this.sqlVar;
        this.queryItems[this.editQueryId].sqlRunIf = this.sqlRunIf;

        this.beforeAfter = null;
        this.pageQueryNum = null;
        this.dbConnId = 0;
        this.sqlQuery = '';
        this.sqlVar = '';
        this.sqlRunIf = '';
        this.$refs.editQuery.resetValidation();
      },
      cancelEditQuery() {
        this.editQueryDialog = false;
        this.beforeAfter = null;
        this.pageQueryNum = null;
        this.dbConnId = 0;
        this.sqlQuery = '';
        this.sqlVar = '';
        this.sqlRunIf = '';
        this.$refs.editQuery.resetValidation();
      },
      deleteQuery(index) {
        this.queryItems.splice(index, 1);
        this.reorderItems('queryItems');
      },
      newElement(type, elementType) {
        this.newElementTitle = this.$t('FORMS.NEW_EDIT_FORM.ELEMENTS.ADD_TITLE') + ' ' + elementType;
        this.newElementText = this.$t('FORMS.NEW_EDIT_FORM.ELEMENTS.ADD_DESC');
        this.varType = type;
        this.varAction = 'save'
        this.newElementDialog = true;
        this.setTabs();
        if(typeof this.$refs.newElement !== 'undefined') {
          this.$refs.newElement.resetValidation();
        }
      },
      cancelNewElement() {
        this.newElementDialog = false;
        this.layout.pop();
        this.snackCancel();
        this.resetDefaults();
        this.$refs.newElement.resetValidation();
      },
      cancelEditElement() {
        this.editElementDialog = false;
        this.snackCancel();
        this.resetDefaults();
        this.$refs.editElement.resetValidation();
      },
      lockElement(item) {
        for(let z = 0; z < this.layout.length; z++) {
          if(this.layout[z].i == item.i) {
            if(item.isLocked) {
              this.layout[z].isLocked = false;
            }else {
              this.layout[z].isLocked = true;
            }
          }
        }
      },
      editElement(item) {
        this.editElementTitle = this.$t('FORMS.NEW_EDIT_FORM.ELEMENTS.EDIT_TITLE') + ' ' + item.elementType;
        this.editElementText = this.$t('FORMS.NEW_EDIT_FORM.ELEMENTS.EDIT_DESC');
        this.varType = item.data.varType;
        this.varName = item.data.varName;
        this.varLabel = item.data.varLabel;
        this.minDate = item.data.minDate;
        this.maxDate = item.data.maxDate;
        this.minTime = item.data.minTime;
        this.maxTime = item.data.maxTime;
        this.varIs24 = item.data.varIs24;
        this.varValue = item.data.varValue;
        this.varIsEmail = item.data.varIsEmail;
        this.varUrl = item.data.varUrl;
        this.varMaxH = item.data.varMaxH;
        this.varMaxW = item.data.varMaxW;
        this.subform = item.data.subform;
        this.varAllowMultiple = item.data.varAllowMultiple;
        this.varAutocalc = item.data.varAutocalc;
        this.radioAsRow = item.data.radioAsRow;
        this.varHidden = item.data.varHidden;
        this.varDisabled = item.data.varDisabled;
        this.varBorderSolid = item.data.varBorderSolid;
        this.varBorderDashed = item.data.varBorderDashed;
        this.varRequired = item.data.varRequired,
        this.varWidth = item.w;
        this.varOffset = item.x;
        this.varAction = 'edit'
        this.currentElementId = item.i;

        // Enable SQL mode
        if(typeof item.data.fieldSql !== 'undefined' && item.data.fieldSql != null && item.data.fieldSql != '') {
          this.enableSql = true;
          this.fieldConnId = item.data.fieldConnId;
          this.fieldSql = item.data.fieldSql;
        }else {
          this.enableSql = false;
        }

        // Add radio items
        if(item.data.varType == 'radio') {
          this.radioItems = item.data.radioItems;
          this.reorderItems('radioItems');
        }

        // Add select items
        if(item.data.varType == 'select' || item.data.varType == 'autocomplete') {
          this.selectItems = item.data.selectItems;
          this.reorderItems('selectItems');
        }

        // Add checkbox items
        if(item.data.varType == 'checkbox') {
          this.checkboxItems = item.data.checkboxItems;
          this.reorderItems('checkboxItems');
        }

        // Add combobox items
        if(item.data.varType == 'combobox') {
          this.comboItems = item.data.comboItems;
          this.reorderItems('comboItems');
        }

        // Add grid items
        if(item.data.varType == 'array') {
          this.gridItems = item.data.gridItems;
          this.allowAdd = item.data.allowAdd;
          this.allowDelete = item.data.allowDelete;
          this.reorderItems('gridItems');
        }

        this.editElementDialog = true;
        this.setTabs();
      },
      updateElement(item) {   
        if(this.varAction == 'save') {
          this.newElementDialog = false;
          this.$refs.newElement.resetValidation();

          // Scroll to bottom
          var scrollMe = document.getElementById('content-container');
          scrollMe.scrollTop = scrollMe.scrollHeight;
        }
        if(this.varAction == 'edit') {
          this.editElementDialog = false;
          this.$refs.editElement.resetValidation();
        }

        for(let j = 0; j < this.layout.length; j++) {
          if(this.currentElementId == this.layout[j].i) {
            if(this.varAction == 'save') {
              if(item.varType != 'group' && item.varType != 'page' && item.varType != 'title' && item.varType != 'subheader' && item.varType != 'para' && item.varType != 'subform') {
                this.layout[j].data = {
                  'varType': item.varType,
                  'varName': item.varName,
                  'varLabel': item.varLabel,
                  'minDate': item.minDate,
                  'maxDate': item.maxDate,
                  'minTime': item.minTime,
                  'maxTime': item.maxTime,
                  'varIs24': item.varIs24,
                  'varValue': item.varValue,
                  'varIsEmail': item.varIsEmail,
                  'varUrl': item.varUrl,
                  'varMaxH': item.varMaxH,
                  'varMaxW': item.varMaxW,
                  'varAllowMultiple': item.varAllowMultiple,
                  'varAutocalc': item.varAutocalc,
                  'radioAsRow': item.radioAsRow,
                  'varHidden': item.varHidden,
                  'varDisabled': item.varDisabled,
                  'varRequired': item.varRequired,
                  'varWidth': parseInt(item.varWidth),
                  'varOffset': parseInt(item.varOffset)
                };
                this.layout[j].w = parseInt(item.varWidth);
                this.layout[j].x = parseInt(item.varOffset);

                // If enableSql
                if(this.enableSql) {
                  this.layout[j].data['fieldSql'] = item.fieldSql;
                  this.layout[j].data['fieldConnId'] = item.fieldConnId;
                }else {
                  this.layout[j].data['fieldSql'] = 0;
                  this.layout[j].data['fieldConnId'] = '';
                }

                // Save radio items
                if(item.varType == 'radio') {
                  this.layout[j].data['radioItems'] = this.radioItems;
                  // Override width
                  this.layout[j].data['varWidth'] = 12;
                  this.layout[j].data['varOffset'] = 0;
                  this.layout[j].w = 12;
                  this.layout[j].x = 0;
                }
                // Save select items
                if(item.varType == 'select' || item.varType == 'autocomplete') {
                  this.layout[j].data['selectItems'] = this.selectItems;
                }
                // Save checkbox items
                if(item.varType == 'checkbox') {
                  this.layout[j].data['checkboxItems'] = this.checkboxItems;
                  // Override width
                  this.layout[j].data['varWidth'] = 12;
                  this.layout[j].data['varOffset'] = 0;
                  this.layout[j].w = 12;
                  this.layout[j].x = 0;
                }
                // Save combobox items
                if(item.varType == 'combobox') {
                  this.layout[j].data['comboItems'] = this.comboItems;
                }
                // Save grid items
                if(item.varType == 'array') {
                  this.layout[j].data['gridItems'] = this.gridItems;
                  this.layout[j].data['allowAdd'] = this.allowAdd;
                  this.layout[j].data['allowDelete'] = this.allowDelete;
                }
              }else {
                if(item.varType == 'page') {
                  this.formCount++;
                  item.varWidth = 12;
                  item.varOffset = 0;

                  this.layout[j].data = {
                    'varType': item.varType,
                    'varLabel': item.varLabel,
                    'varWidth': parseInt(item.varWidth),
                    'varOffset': parseInt(item.varOffset)
                  };
                  this.layout[j].w = parseInt(item.varWidth);
                  this.layout[j].x = parseInt(item.varOffset);
                }else if(item.varType == 'subheader') {
                  this.subheaders++;

                  this.layout[j].data = {
                    'varType': item.varType,
                    'varName': "subheader" + this.subheaders,
                    'varLabel': item.varLabel,
                    'varHidden': item.varHidden,
                    'varWidth': parseInt(item.varWidth),
                    'varOffset': parseInt(item.varOffset)
                  };
                  this.layout[j].w = parseInt(item.varWidth);
                  this.layout[j].x = parseInt(item.varOffset);
                }else if(item.varType == 'para') {
                  this.paragraphs++;

                  this.layout[j].data = {
                    'varType': item.varType,
                    'varName': "para" + this.paragraphs,
                    'varLabel': item.varLabel,
                    'varWidth': parseInt(item.varWidth),
                    'varOffset': parseInt(item.varOffset)
                  };
                  this.layout[j].w = parseInt(item.varWidth);
                  this.layout[j].x = parseInt(item.varOffset);
                }else if(item.varType == 'subform') {
                  item.varWidth = 12;
                  item.varOffset = 0;
                  
                  for(let i = 0; i < this.subformList.length; i++) {
                    if(this.subformList[i].FORM_KEY == item.subform) {
                      item.varLabel = "Subform: " + this.subformList[i].FORM_TITLE;
                      break;
                    }
                  }

                  this.layout[j].data = {
                    'varType': item.varType,
                    'varLabel': item.varLabel,
                    'subform': item.subform,
                    'varDisabled': item.varDisabled,
                    'varBorderSolid': item.varBorderSolid,
                    'varBorderDashed': item.varBorderDashed,
                    'varWidth': parseInt(item.varWidth),
                    'varOffset': parseInt(item.varOffset)
                  };
                  this.layout[j].w = parseInt(item.varWidth);
                  this.layout[j].x = parseInt(item.varOffset);
                }
              }
            }
            if(this.varAction == 'edit') {

              if(item.varType != 'group' && item.varType != 'page' && item.varType != 'subform') {
                if(this.enableSql) {
                  this.layout[j].data.fieldConnId = item.fieldConnId;
                  this.layout[j].data.fieldSql = item.fieldSql;
                }else {
                  this.layout[j].data.fieldConnId = 0;
                  this.layout[j].data.fieldSql = '';
                }

                this.layout[j].data.varType = item.varType;
                this.layout[j].data.varName = item.varName;
                this.layout[j].data.varLabel = item.varLabel;
                this.layout[j].data.minDate = item.minDate;
                this.layout[j].data.maxDate = item.maxDate;
                this.layout[j].data.minTime = item.minTime;
                this.layout[j].data.maxTime = item.maxTime;
                this.layout[j].data.varIs24 = item.varIs24;
                this.layout[j].data.varValue = item.varValue;
                this.layout[j].data.varIsEmail = item.varIsEmail;
                this.layout[j].data.varUrl = item.varUrl;
                this.layout[j].data.varMaxH = item.varMaxH;
                this.layout[j].data.varMaxW = item.varMaxW;
                this.layout[j].data.subform = item.subform;
                this.layout[j].data.varAllowMultiple = item.varAllowMultiple;
                this.layout[j].data.varAutocalc = item.varAutocalc;
                this.layout[j].data.radioAsRow = item.radioAsRow;
                this.layout[j].data.varHidden = item.varHidden;
                this.layout[j].data.varDisabled = item.varDisabled;
                this.layout[j].data.varRequired = item.varRequired;
                this.layout[j].data.varWidth = parseInt(item.varWidth);
                this.layout[j].data.varOffset = parseInt(item.varOffset);
                this.layout[j].w = parseInt(item.varWidth);
                this.layout[j].x = parseInt(item.varOffset);

                // Save radio items
                if(item.varType == 'radio') {
                  this.layout[j].data.radioItems = this.radioItems;
                  // Override width
                  this.layout[j].data.varWidth = 12;
                  this.layout[j].data.varOffset = 0;
                  this.layout[j].w = 12;
                  this.layout[j].x = 0;
                }
                // Save select items
                if(item.varType == 'select' || item.varType == 'autocomplete') {
                  this.layout[j].data.selectItems = this.selectItems;
                }
                // Save checkbox items
                if(item.varType == 'checkbox') {
                  this.layout[j].data.checkboxItems = this.checkboxItems;
                  // Override width
                  this.layout[j].data.varWidth = 12;
                  this.layout[j].data.varOffset = 0;
                  this.layout[j].w = 12;
                  this.layout[j].x = 0;
                }
                // Save combobox items
                if(item.varType == 'combobox') {
                  this.layout[j].data.comboItems = this.comboItems;
                }
                // Save grid items
                if(item.varType == 'array') {
                  this.layout[j].data.gridItems = this.gridItems;
                  this.layout[j].data.allowAdd = this.allowAdd;
                  this.layout[j].data.allowDelete = this.allowDelete;
                }
              }else {
                if(item.varType == 'page') {
                  item.varWidth = 12;
                  item.varOffset = 0;
                  this.layout[j].data.varLabel = item.varLabel;
                  this.layout[j].data.varWidth = parseInt(item.varWidth);
                  this.layout[j].data.varOffset = parseInt(item.varOffset);
                  this.layout[j].w = parseInt(item.varWidth);
                  this.layout[j].x = parseInt(item.varOffset);
                }else if(item.varType == 'subheader') {
                  this.layout[j].data.varName = item.varName;
                  this.layout[j].data.varLabel = item.varLabel;
                  this.layout[j].data.varHidden = item.varHidden;
                  this.layout[j].data.varWidth = parseInt(item.varWidth);
                  this.layout[j].data.varOffset = parseInt(item.varOffset);
                  this.layout[j].w = parseInt(item.varWidth);
                  this.layout[j].x = parseInt(item.varOffset);
                }else if(item.varType == 'para') {
                  this.layout[j].data.varName = item.varName;
                  this.layout[j].data.varLabel = item.varLabel;
                  this.layout[j].data.varWidth = parseInt(item.varWidth);
                  this.layout[j].data.varOffset = parseInt(item.varOffset);
                  this.layout[j].w = parseInt(item.varWidth);
                  this.layout[j].x = parseInt(item.varOffset);
                }else if(item.varType == 'subform') {

                  for(let i = 0; i < this.subformList.length; i++) {
                    if(this.subformList[i].FORM_KEY == item.subform) {
                      item.varLabel = "Subform: " + this.subformList[i].FORM_TITLE;
                      break;
                    }
                  }

                  this.layout[j].data.varLabel = item.varLabel;
                  this.layout[j].data.subform = item.subform;
                  this.layout[j].data.varDisabled = item.varDisabled;
                  this.layout[j].data.varBorderSolid = item.varBorderSolid;
                  this.layout[j].data.varBorderDashed = item.varBorderDashed;
                  this.layout[j].data.varWidth = parseInt(item.varWidth);
                  this.layout[j].data.varOffset = parseInt(item.varOffset);
                  this.layout[j].w = parseInt(item.varWidth);
                  this.layout[j].x = parseInt(item.varOffset);
                }
              }
            }
            if(this.varAction == 'moved') {
              this.layout[j].data.varOffset = item.x;
            }
            if(this.varAction == 'resized' && item.varType != 'group') {
              this.layout[j].data.varWidth = item.w;
            }
          }
        }
        
        this.snackSave();
        this.resetDefaults();
      },
      async buildSchema(action) {
        // Resets
        this.isMulti = 0;
        this.tempSchema = {};
        let currentForm = 0;
        let groupCount = 1;
        this.subs = [];

        // Sort by X (offset), then Y (row number) - used to make sure elements are displayed in the correct order on the form
        this.layout.sort((a, b) => parseFloat(a.x) - parseFloat(b.x));
        this.layout.sort((a, b) => parseFloat(a.y) - parseFloat(b.y));

        // Reorder paragraphs
        let pg = 0;
        for(let ly = 0; ly < this.layout.length; ly++) {
          if(this.layout[ly].data.varType == 'para') {
            this.layout[ly].data.varName = "para" + pg;
            pg++;
          }
        }
        
        let items = this.layout;

        let theSchema = {
          "forms": [
            {
              "group0": {
                "type": "wrap",
                "elevation": 0,
                "step": 1,
                "title": this.formTitle,
                "ripple": false,
                "sqlQueries": this.queryItems,
                "schema": {

                }
              }
            }
          ]
        };

        // Check if PDF is required
        if(this.pdfTemplateId !== null) {
          theSchema.forms[0].group0.pdfTemplateId = this.pdfTemplateId;
        }
        
        for(let i = 0; i < items.length; i++) {
          if(action == 'save') {
            // Add variable name to list
            if(items[i].data.varType != 'page' && items[i].data.varType != 'title' && items[i].data.varType != 'subheader' && items[i].data.varType != 'para') {
              let varFound = false;

              for(let v = 0; v < this.availableVars.length; v++) {
                if(this.availableVars[v].varName == items[i].data.varName) {
                  varFound = true;
                }
              }
              if(!varFound) {
                this.availableVars.push({ 'varName': items[i].data.varName, 'varType': items[i].data.varType });
              }
            }
          }

          // Is this a page?
          if(items[i].data.varType == 'page') {
            this.isMulti = 1;
            let schema = this.tempSchema;
            let theGroup = 'group' + groupCount;
            // End the current form (if schema not empty)
            if(Object.keys(schema).length != 0) {
              theSchema.forms[currentForm][theGroup] = {
                  "type": "wrap",
                  "col": 12,
                  "elevation": 0,
                  "ripple": false,
                  schema
                };
            }

            this.tempSchema = {};
            currentForm++;

            // Start the new form
            groupCount = 1;
            theSchema.forms.push({'group0': {
                "type": "wrap",
                "col": 12,
                "elevation": 0,
                "step": currentForm + 1,
                "title": items[i].data.varLabel,
                "ripple": false,
                "schema": {

                }
              }});
          }else {
            // Any validation rules to add?
            let customRules = [];
            let prependIcon = '';
            let prependPadding = '';
            if(items[i].data.varRequired) {
              if((items[i].data.varType == 'text' && !items[i].data.varIsEmail) || items[i].data.varType == 'textarea' || items[i].data.varType == 'combobox') {
                customRules.push("requiredText");
              }else if(items[i].data.varType == 'number') {
                customRules.push("requiredNumber");
              }else if(items[i].data.varType == 'select' || items[i].data.varType == 'autocomplete') {
                customRules.push("requiredSelect");
              }else if(items[i].data.varType == 'radio') {
                customRules.push("requiredRadio");
              }else if(items[i].data.varType == 'date') {
                customRules.push("requiredDate");
              }else if(items[i].data.varType == 'time') {
                customRules.push("requiredTime");
              }else if(items[i].data.varType == 'file') {
                customRules.push("requiredFile");
              }else if(items[i].data.varType == 'text' && items[i].data.varIsEmail) {
                customRules.push("requiredEmail", "validEmail");
              }
              prependIcon = 'mdi-star-outline';
            }else if(items[i].data.varIsEmail) {
              customRules.push("validEmail");
              prependPadding = 'pl-8';
            }else {
              prependPadding = 'pl-8';
            }

            // Look for the last element in the row
            if(i > 0 && (items[i].y != items[i-1].y)) {
              let endRowOffset = 12 - (items[i-1].data.varOffset + items[i-1].data.varWidth);
              // If field is the same size or less than remaining space, add a spacer
              if(items[i].data.varWidth <= endRowOffset) {
                let spacerName = 'spacer' + i;
                this.tempSchema[spacerName] = {
                  "type": "text",
                  "disabled": true,
                  "spacer": true,
                  "class": "hidden-spacer",
                  "col": { "md": endRowOffset }
                };
              }
            }

            // General schema
            if(items[i].data.varType != 'checkbox' && items[i].data.varType != 'radio' && items[i].data.varType != 'file' && items[i].data.varType != 'date' && items[i].data.varType != 'time' && items[i].data.varType != 'title' && items[i].data.varType != 'subheader' && items[i].data.varType != 'para' && items[i].data.varType != 'link' && items[i].data.varType != 'img' && items[i].data.varType != 'array' && items[i].data.varType != 'subform') {
              this.tempSchema[items[i].data.varName] = {
                "type": items[i].data.varType,
                "label": items[i].data.varLabel,
                // "hidden" : items[i].data.varHidden,
                "hide" : items[i].data.varHidden,
                "required" : items[i].data.varRequired,
                "readonly" : items[i].data.varDisabled,
                "disabled" : items[i].data.varDisabled,
                "fieldConnId": items[i].data.fieldConnId,
                "fieldSql": items[i].data.fieldSql,
                "id": items[i].data.varName,
                "name": items[i].data.varName,
                "customRules": customRules,
                "prependIcon": prependIcon,
                "class": prependPadding + " v-text-field--outlined",
                "col": { "xs": 12, "sm": 12, "md": parseInt(items[i].data.varWidth) },
                "ripple": false
              };
            }

            // Check for subform
            if(items[i].data.varType == 'subform') {
              await this.$store.dispatch('getSubform', items[i].data.subform).then( () => {

                // End the current group if there is data
                let theGroup = 'group' + groupCount;
                let schema = this.tempSchema;
                if(Object.keys(schema).length != 0) {
                  theSchema.forms[currentForm][theGroup] = {
                      "type": "wrap",
                      "col": 12,
                      "elevation": 0,
                      "ripple": false,
                      schema
                    };

                  this.tempSchema = {};
                  groupCount++;
                }

                // Add the subform group
                let subformKeys = Object.keys(this.subformSchema.forms[0].group1.schema);

                // Find and rename subheaders to prevent duplicates
                subformKeys.forEach((skey) => {
                  if(this.subformSchema.forms[0].group1.schema[skey].type == 'subheader') {
                    let newId = skey + 999;
                    this.subformSchema.forms[0].group1.schema[skey].id = newId;
                    this.subs.push({ 'id': newId, 'text': this.subformSchema.forms[0].group1.schema[skey].text });
                  }
                });

                // Find and rename paragraphs to prevent duplicates
                subformKeys.forEach((skey) => {
                  if(this.subformSchema.forms[0].group1.schema[skey].type == 'para') {
                    let newId = skey + 999;
                    this.subformSchema.forms[0].group1.schema[skey].id = newId;
                    this.paras.push({ 'id': newId, 'text': this.subformSchema.forms[0].group1.schema[skey].text });
                  }
                });

                // Is there a grid?
                subformKeys.forEach((skey) => {
                  if(this.subformSchema.forms[0].group1.schema[skey].type == 'array') {
                    let theItems = {};
                    let defaultItems = {};
                    let gridKeys = Object.keys(this.subformSchema.forms[0].group1.schema[skey].schema.items.schema);
                    gridKeys.forEach(gkey => {
                      if(typeof this.subformSchema.forms[0].group1.schema[skey].schema.items.schema[gkey].value !== 'undefined') {
                        theItems[gkey] = this.subformSchema.forms[0].group1.schema[skey].schema.items.schema[gkey].value;
                        defaultItems[gkey] = this.subformSchema.forms[0].group1.schema[skey].schema.items.schema[gkey].value;
                      }else {
                        if(this.subformSchema.forms[0].group1.schema[skey].schema.items.schema[gkey].type == 'wrap') {
                          // Checkbox
                          let gridCheckKeys = Object.keys(this.subformSchema.forms[0].group1.schema[skey].schema.items.schema[gkey].schema);
                      
                          gridCheckKeys.forEach(ckey => {
                            if(typeof this.subformSchema.forms[0].group1.schema[skey].schema.items.schema[gkey].schema[ckey] !== 'undefined') {
                              theItems[ckey] = this.subformSchema.forms[0].group1.schema[skey].schema.items.schema[gkey].schema[ckey].value;
                              defaultItems[ckey] = this.subformSchema.forms[0].group1.schema[skey].schema.items.schema[gkey].schema[ckey].value;
                            }
                          });
                        }
                      }

                    });
                    this.formModel[skey] = [{'items': []}];
                    
                    // Add a row
                    let newRow = {};
                    let defaultKeys = Object.keys(defaultItems);
                    
                    defaultKeys.forEach(dkey => {
                      newRow[dkey] = defaultItems[dkey];
                    });

                    this.formModel[skey][0].items.push(newRow);
                  }
                });

                // If disabled, mark all subform fields as disabled/readonly
                if(items[i].data.varDisabled) {
                  subformKeys.forEach((skey) => {
                    if(!skey.includes('spacer')) {
                      if("readonly" in this.subformSchema.forms[0].group1.schema[skey] || "disabled" in this.subformSchema.forms[0].group1.schema[skey]) {
                        if(this.subformSchema.forms[0].group1.schema[skey].type == "file") {
                          this.subformSchema.forms[0].group1.schema[skey].disabled = true;
                        }else {
                          this.subformSchema.forms[0].group1.schema[skey].readonly = true;
                          this.subformSchema.forms[0].group1.schema[skey].disabled = true;
                        }

                        if(this.subformSchema.forms[0].group1.schema[skey].type == "date" || this.subformSchema.forms[0].group1.schema[skey].type == "time") {
                          this.subformSchema.forms[0].group1.schema[skey].text.readonly = true;
                          this.subformSchema.forms[0].group1.schema[skey].text.disabled = true;
                        }

                        if(this.subformSchema.forms[0].group1.schema[skey].type == "array") {
                          if(this.subformSchema.forms[0].group1.schema[skey].arrayType == "grid") {
                            this.subformSchema.forms[0].group1.schema[skey].schema.gridAddRow.disabled = true;
                            this.subformSchema.forms[0].group1.schema[skey].schema.gridAddRow.readonly = true;

                            let itemArrKeys = Object.keys(this.subformSchema.forms[0].group1.schema[skey].schema.items.schema);
                            itemArrKeys.forEach((ikey) => {
                              this.subformSchema.forms[0].group1.schema[skey].schema.items.schema[ikey].readonly = true;
                              this.subformSchema.forms[0].group1.schema[skey].schema.items.schema[ikey].disabled = true;
                            });
                          }

                          if(this.subformSchema.forms[0].group1.schema[skey].arrayType == "checkbox") {
                            let subItemKeys = Object.keys(this.subformSchema.forms[0].group1.schema[skey].schema.items.schema);
                            subItemKeys.forEach((sikey) => {
                              this.subformSchema.forms[0].group1.schema[skey].schema.items.schema[sikey]['readonly'] = true;
                              this.subformSchema.forms[0].group1.schema[skey].schema.items.schema[sikey]['disabled'] = true;
                            });
                          }
                        }
                      }
                    }
                  });
                }

                // Check for a border
                let borderClass = '';
                if(items[i].data.varBorderSolid) {
                  borderClass = 'subform-border-solid';
                }
                if(items[i].data.varBorderDashed) {
                  borderClass = 'subform-border-dashed';
                }

                schema = this.subformSchema.forms[0].group1.schema;
                theGroup = 'group' + groupCount;
                theSchema.forms[currentForm][theGroup] = {
                    "type": "wrap",
                    "col": 12,
                    "elevation": 0,
                    // "disabled": items[i].data.varDisabled,
                    "class": borderClass,
                    "ripple": false,
                    schema
                  };

                groupCount++;
              });
            }

            // Check for subtitle
            if(items[i].data.varType == 'subheader') {
              if(action == 'initial') {
                this.subheaders++;
              }
              
              let subId = 'subheader' + i;
              // Set variable name to new subId
              items[i].data.varName = subId;
              this.tempSchema[subId] = {
                "type": items[i].data.varType,
                "id": subId,
                "text": items[i].data.varLabel,
                // "hidden" : items[i].data.varHidden,
                "hide" : items[i].data.varHidden,
                "fieldConnId": items[i].data.fieldConnId,
                "fieldSql": items[i].data.fieldSql,
                "col": { "xs": 12, "sm": 12, "md": parseInt(items[i].data.varWidth) },
                "class": "text-h6 pl-0 mb-4 text-sm text-body",
                "ripple": false
              };
              this.subs.push({ 'id': subId, 'text': items[i].data.varLabel });
            }

            // Check for paragraphs
            if(items[i].data.varType == 'para') {
              if(action == 'initial') {
                this.paragraphs++;
              }

              let paraId = 'para' + i;
              this.tempSchema[items[i].data.varName] = {
                "type": "subheader",
                "id": paraId,
                "text": items[i].data.varLabel,
                "fieldConnId": items[i].data.fieldConnId,
                "fieldSql": items[i].data.fieldSql,
                "col": { "xs": 12, "sm": 12, "md": parseInt(items[i].data.varWidth) },
                "class": "text-body-1 pl-0 para-height",
                "ripple": false
              };
              this.subs.push({ 'id': paraId, 'text': items[i].data.varLabel });
            }

            // Add default value for text and number
            if(items[i].data.varType == 'text' || items[i].data.varType == 'number') {
              this.tempSchema[items[i].data.varName]['value'] = items[i].data.varValue;
            }

            // Check for combobox
            if(items[i].data.varType == 'combobox') {
              let options = [];

              for(let j = 0; j < items[i].data.comboItems.length; j++) {
                options.push(items[i].data.comboItems[j].itemName);
              }
              this.tempSchema[items[i].data.varName]['items'] = options;
            }

            // Check for textarea
            if(items[i].data.varType == 'textarea') {
              this.tempSchema[items[i].data.varName]['value'] = items[i].data.varValue;
              // this.tempSchema[items[i].data.varName]['autoGrow'] = true;
              // if(items[i].data.varDisabled) {
              //   this.tempSchema[items[i].data.varName]['noResize'] = true;
              // }
            }

            // Check for number
            if(items[i].data.varType == 'number') {
              this.tempSchema[items[i].data.varName]['autocalc'] = items[i].data.varAutocalc;
            }

            // Check for date
            if(items[i].data.varType == 'date') {
              this.tempSchema[items[i].data.varName] = {
                "type": items[i].data.varType,
                "ext": "text",
                "locale": this.$t('GENERAL.LOCALE'),
                "text": { "label": items[i].data.varLabel, "readonly" : items[i].data.varDisabled, "disabled" : items[i].data.varDisabled },
                "id": items[i].data.varName,
                "fieldConnId": items[i].data.fieldConnId,
                "fieldSql": items[i].data.fieldSql,
                // "hidden" : items[i].data.varHidden,
                "disabled": items[i].data.varDisabled,
                "hide" : items[i].data.varHidden,
                "menu": { "closeOnContentClick": false },
                "min":  items[i].data.minDate, 
                "max": items[i].data.maxDate,
                "col": { "xs": 12, "sm": 12, "md": parseInt(items[i].data.varWidth) },
                "ripple": false,
                "class": ""
              };

              if(items[i].data.varRequired) {
                this.tempSchema[items[i].data.varName]['required'] = items[i].data.varRequired;
                this.tempSchema[items[i].data.varName]['text']['class'] = 'pl-0';
                this.tempSchema[items[i].data.varName]['customRules'] = customRules;
                this.tempSchema[items[i].data.varName]['text']['prependIcon'] = prependIcon;
              }

              if(items[i].data.varHidden) {
                this.tempSchema[items[i].data.varName]['text']['class'] += ' hidden-spacer';
              }
            }

            // Check for time
            if(items[i].data.varType == 'time') {
              let format = "24hr";

              if(!items[i].data.varIs24) {
                format = "ampm";
              }

              this.tempSchema[items[i].data.varName] = {
                "type": items[i].data.varType,
                "format": format,
                "ext": "text",
                "text": { "label": items[i].data.varLabel, "readonly" : items[i].data.varDisabled, "disabled" : items[i].data.varDisabled, "prependIcon": prependIcon },
                // "hidden" : items[i].data.varHidden,
                "disabled": items[i].data.varDisabled,
                "hide" : items[i].data.varHidden,
                "required" : items[i].data.varRequired,
                "id": items[i].data.varName,
                "fieldConnId": items[i].data.fieldConnId,
                "fieldSql": items[i].data.fieldSql,
                "min":  items[i].data.minTime, 
                "max": items[i].data.maxTime,
                "customRules": customRules,
                "col": { "xs": 12, "sm": 12, "md": parseInt(items[i].data.varWidth) },
                "ripple": false,
                "class": ""
              };

              if(items[i].data.varRequired) {
                this.tempSchema[items[i].data.varName]['text']['class'] = 'pl-0';
              }

              if(items[i].data.varHidden) {
                this.tempSchema[items[i].data.varName]['text']['class'] += ' hidden-spacer';
              }
            }

            // Check for radio
            if(items[i].data.varType == 'radio') {
              // Set label
              let labelName = items[i].data.varName + '_label';
              this.tempSchema[labelName] = {
                "type": "subheader",
                "id": labelName,
                "text": items[i].data.varLabel,
                "col": { "xs": 12, "sm": 12, "md": 12 },
                "class": "text-body-0 pl-0",
                "ripple": false
              };
              this.subs.push({ 'id': labelName, 'text': items[i].data.varLabel });

              this.tempSchema[items[i].data.varName] = {
                "type": items[i].data.varType,
                // "label": items[i].data.varLabel,
                // "hidden" : items[i].data.varHidden,
                "hide" : items[i].data.varHidden,
                "required" : items[i].data.varRequired,
                "readonly" : items[i].data.varDisabled,
                "disabled" : items[i].data.varDisabled,
                "fieldConnId": items[i].data.fieldConnId,
                "fieldSql": items[i].data.fieldSql,
                "id": items[i].data.varName,
                "name": items[i].data.varName,
                "customRules": customRules,
                "prependIcon": prependIcon,
                "class": prependPadding + " v-text-field--outlined",
                "col": { "xs": 12, "sm": 12, "md": parseInt(items[i].data.varWidth) },
                "ripple": false
              };

              this.tempSchema[items[i].data.varName]['row'] = items[i].data.radioAsRow;
              let options = [];

              for(let j = 0; j < items[i].data.radioItems.length; j++) {
                options.push({ "label": items[i].data.radioItems[j].label, "value": items[i].data.radioItems[j].value });
              }
              this.tempSchema[items[i].data.varName]['options'] = options;
            }

            // Check for select and autocomplete
            if(items[i].data.varType == 'select' || items[i].data.varType == 'autocomplete') {
              this.tempSchema[items[i].data.varName]['itemText'] = "name";
              this.tempSchema[items[i].data.varName]['itemValue'] = "val";
              let options = [];

              for(let j = 0; j < items[i].data.selectItems.length; j++) {
                options.push({ "name": items[i].data.selectItems[j].itemText, "val": items[i].data.selectItems[j].itemValue });
              }
              this.tempSchema[items[i].data.varName]['items'] = options;
              this.tempSchema[items[i].data.varName]['multiple'] = items[i].data.varAllowMultiple;
            }

            // Check for checkbox
            if(items[i].data.varType == 'checkbox') {
              // Set label
              let labelName = items[i].data.varName + '_label';
              this.tempSchema[labelName] = {
                "type": "subheader",
                "id": labelName,
                "text": items[i].data.varLabel,
                "col": { "xs": 12, "sm": 12, "md": 12 },
                "class": "text-body-0 pl-0",
                "ripple": false
              };
              this.subs.push({ 'id': labelName, 'text': items[i].data.varLabel });

              let options = {};
              let pData = {};

              for(let j = 0; j < items[i].data.checkboxItems.length; j++) {
                options[items[i].data.checkboxItems[j].variableName] = { 
                  "type": "checkbox", 
                  "label": items[i].data.checkboxItems[j].label, 
                  "id": items[i].data.checkboxItems[j].variableName,
                  "parent": items[i].data.varName,
                  "class": prependPadding,
                  "col": { "xs": 12, "sm": 12, "md": items[i].data.checkboxItems[j].width },
                  "ripple": false
                };

                if(items[i].data.varDisabled) {
                  options[items[i].data.checkboxItems[j].variableName]['readonly'] = true;
                  options[items[i].data.checkboxItems[j].variableName]['disabled'] = true;
                }
                
                if(items[i].data.checkboxItems[j].isRequired) {
                  options[items[i].data.checkboxItems[j].variableName]['required'] = true;
                  options[items[i].data.checkboxItems[j].variableName]['customRules'] = ["requiredCheckbox"];
                  options[items[i].data.checkboxItems[j].variableName]['prependIcon'] = 'mdi-star-outline';
                  options[items[i].data.checkboxItems[j].variableName]['class'] = '';
                }
                if(items[i].data.varRequired && j == 0) {
                  options[items[i].data.checkboxItems[j].variableName]['prependIcon'] = 'mdi-star-outline';
                }
                if(items[i].data.checkboxItems[j].isChecked) {
                  options[items[i].data.checkboxItems[j].variableName]['value'] = true;
                  pData[[items[i].data.checkboxItems[j].variableName]] = true;
                }else {
                  pData[[items[i].data.checkboxItems[j].variableName]] = false;
                }
              }
              
              this.tempSchema[items[i].data.varName] = {
                    "type": "array",
                    "arrayType": "checkbox",
                    "elevation": 0,
                    "subtitle": items[i].data.varLabel,
                    // "hidden" : items[i].data.varHidden,
                    "hide" : items[i].data.varHidden,
                    "readonly" : items[i].data.varDisabled,
                    "disabled" : items[i].data.varDisabled,
                    "fieldConnId": items[i].data.fieldConnId,
                    "fieldSql": items[i].data.fieldSql,
                    "id": items[i].data.varName,
                    "col": { "xs": 12, "sm": 12, "md": parseInt(items[i].data.varWidth) },
                    "ripple": false,
                    "schema": { "items": { "col": 12, "type": "array", "schema" : options } }
              };

              if(items[i].data.varRequired) {
                this.tempSchema[items[i].data.varName]['required'] = true;
                this.tempSchema[items[i].data.varName]['customRules'] = ["requiredCheckboxAll"];
                this.tempSchema[items[i].data.varName]['class'] = '';
              }

              if(items[i].data.varHidden) {
                this.tempSchema[items[i].data.varName]['class'] = '';
              }

              this.formModel[items[i].data.varName] = [{'items': [pData]}];
            }

            // Check for file (1 col width is removed to allow for upload button)
            if(items[i].data.varType == 'file') {
              this.tempSchema[items[i].data.varName] = {
                "type": items[i].data.varType,
                "label": items[i].data.varLabel,
                "id": items[i].data.varName,
                "multiple": items[i].data.varAllowMultiple,
                // "hidden" : items[i].data.varHidden,
                "hide" : items[i].data.varHidden,
                "required" : items[i].data.varRequired,
                "disabled" : items[i].data.varDisabled,
                "customRules": customRules,
                "prependIcon": prependIcon,
                "class": prependPadding + " v-text-field--outlined",
                "col": { "xs": 12, "sm": 12, "md": (parseInt(items[i].data.varWidth) - 1) },
                "ripple": false
              };

              // Add and link upload button
              let btnVariable = items[i].data.varName + 'Btn';
              this.tempSchema[btnVariable] = {
                "type": "btn",
                "label": "Upload",
                "iconRight": "mdi-cloud-upload",
                "depressed": true,
                "color" : "warning",
                "loading" : false,
                "linkedto": items[i].data.varName,
                "height": "52px",
                "class": "file-uploader mt-4 ml-2",
                "col": { "xs": 12, "sm": 12, "md": 1 },
                "ripple": false
              };
            }

            // Check for image
            if(items[i].data.varType == 'img') {
              this.tempSchema[items[i].data.varName] = {
                "type": items[i].data.varType,
                "src": items[i].data.varUrl,
                "maxHeight": items[i].data.varMaxH,
                "maxWidth": items[i].data.varMaxW,
                "label": items[i].data.varLabel,
                // "hidden" : items[i].data.varHidden,
                "hide" : items[i].data.varHidden,
                "id": items[i].data.varName,
                "class": "image-border",
                "col": { "xs": 12, "sm": 12, "md": parseInt(items[i].data.varWidth) },
                "ripple": false
              };
            }

            // Check for hyperlink
            if(items[i].data.varType == 'link') {
              let link = "<a href='" + items[i].data.varUrl + "' target='_blank'>" + items[i].data.varLabel + "</a>"
              this.tempSchema[items[i].data.varName] = {
                "type": "subheader",
                "text": link,
                // "hidden" : items[i].data.varHidden,
                "hide" : items[i].data.varHidden,
                "id": items[i].data.varName,
                "col": { "xs": 12, "sm": 12, "md": parseInt(items[i].data.varWidth) },
                "class": "text-body-1 mt-4",
                "ripple": false
              };

              this.subs.push({ 'id': items[i].data.varName, 'text': link });
            }

            // Check for grid
            if(items[i].data.varType == 'array') {
              let gridOptions = {};
              let theItems = {};
              
              for(let j = 0; j < items[i].data.gridItems.length; j++) {
                gridOptions[items[i].data.gridItems[j].fieldVarName] = { 
                  "type": items[i].data.gridItems[j].fieldType, 
                  "label": items[i].data.gridItems[j].fieldName, 
                  "col": items[i].data.gridItems[j].fieldWidth,
                  "fieldConnId": items[i].data.gridItems[j].fieldConnId,
                  "fieldSql": items[i].data.gridItems[j].fieldSql,
                  "readonly" : items[i].data.varDisabled,
                  "class": "v-text-field--outlined",
                  "ripple": false
                };
                if(typeof items[i].data.gridItems[j].fieldDefault !== 'undefined' && items[i].data.gridItems[j].fieldDefault != null) {
                  if(items[i].data.gridItems[j].fieldType == 'number') {
                    theItems[[items[i].data.gridItems[j].fieldVarName]] = parseInt(items[i].data.gridItems[j].fieldDefault);
                    gridOptions[items[i].data.gridItems[j].fieldVarName]['value'] = parseInt(items[i].data.gridItems[j].fieldDefault);
                  }else {
                    theItems[[items[i].data.gridItems[j].fieldVarName]] = items[i].data.gridItems[j].fieldDefault;
                    gridOptions[items[i].data.gridItems[j].fieldVarName]['value'] = items[i].data.gridItems[j].fieldDefault;
                  }
                }
                
                // Check for select and autocomplete
                if(items[i].data.gridItems[j].fieldType == 'select' || items[i].data.gridItems[j].fieldType == 'autocomplete') {
                  gridOptions[items[i].data.gridItems[j].fieldVarName]['itemText'] = "name";
                  gridOptions[items[i].data.gridItems[j].fieldVarName]['itemValue'] = "val";
                  let itemOptions = [];

                  for(let k = 0; k < items[i].data.gridItems[j].configSelectItems.length; k++) {
                    itemOptions.push({ "name": items[i].data.gridItems[j].configSelectItems[k].itemText, "val": items[i].data.gridItems[j].configSelectItems[k].itemValue });
                  }
                  gridOptions[items[i].data.gridItems[j].fieldVarName]['items'] = itemOptions;
                  gridOptions[items[i].data.gridItems[j].fieldVarName]['multiple'] = items[i].data.gridItems[j].fieldMulti;
                }

                // Check for combobox
                if(items[i].data.gridItems[j].fieldType == 'combobox') {
                  let itemOptions = [];

                  for(let l = 0; l < items[i].data.gridItems[j].configComboItems.length; l++) {
                    itemOptions.push(items[i].data.gridItems[j].configComboItems[l].itemName);
                  }
                  gridOptions[items[i].data.gridItems[j].fieldVarName]['items'] = itemOptions;
                }

                // Check for checkbox
                if(items[i].data.gridItems[j].fieldType == 'checkbox') {
                  gridOptions[items[i].data.gridItems[j].fieldVarName].class = "v-text-field--outlined check-grid-item";
                }
              }

              // Add delete btn
              if(items[i].data.allowDelete) {
                gridOptions['gridDeleteRow'] = {
                  "type": "btn",
                  "col": 1,
                  "iconCenter": "mdi-trash-can-outline",
                  "color": "error",
                  "xSmall": true,
                  "class": "mt-8 grid-delete-row",
                  "gname": items[i].data.varName,
                  "disabled" : items[i].data.varDisabled,
                  "ripple": false
                };
              }

              // Allow add button
              let gridAddRow = {};
              if(items[i].data.allowAdd) {
                gridAddRow = {
                  "type": "btn",
                  "col": 12,
                  "iconCenter": "mdi-plus",
                  "color": "success",
                  "class": "mb-4 grid-add-row",
                  "gname": items[i].data.varName,
                  "disabled" : items[i].data.varDisabled,
                  "ripple": false
                };
              }

              this.tempSchema[items[i].data.varName] = {
                    "type": "array",
                    "arrayType": "grid",
                    "elevation": 0,
                    "subtitle": items[i].data.varLabel,
                    // "hidden" : items[i].data.varHidden,
                    "hide" : items[i].data.varHidden,
                    "readonly" : items[i].data.varDisabled,
                    "id": items[i].data.varName,
                    "class": "grid-element pl-8",
                    "col": { "xs": 12, "sm": 12, "md": parseInt(items[i].data.varWidth) },
                    "ripple": false,
                    "schema": {
                      gridAddRow,
                      "items": {
                        "type": "array",
                        "col": 12,
                        "schema": gridOptions
                      }
                    }
              };
              
              // Add to model
              this.formModel[items[i].data.varName] = [{'items': [theItems]}];
            }

            // Check for default value and add to model
            if(items[i].data.varValue !== null) {
              this.formModel[items[i].data.varName] = items[i].data.varValue;
            }

            if(parseInt(items[i].data.varOffset) > 0) {
              if(i > 0 && (items[i].y == items[i-1].y)) {
                // On the same row, so minus the width of previous element
                let actualOffset = parseInt(items[i].data.varOffset) - parseInt(items[i-1].data.varWidth) - parseInt(items[i-1].data.varOffset);
                if(actualOffset > 0) {
                  this.tempSchema[items[i].data.varName]['offset'] = { "offset": 0, "md": actualOffset };
                }
              }else {
                this.tempSchema[items[i].data.varName]['offset'] = { "offset": 0, "md": parseInt(items[i].data.varOffset) };
              }
            }
          }

          // Allow hidden fields to remain in place, preventing floating
          if(items[i].data.varType == 'text' || items[i].data.varType == 'textarea' || items[i].data.varType == 'number' || items[i].data.varType == 'img' || items[i].data.varType == 'array' || items[i].data.varType == 'autocomplete' || items[i].data.varType == 'select' || items[i].data.varType == 'link' || items[i].data.varType == 'file' || items[i].data.varType == 'combobox' || items[i].data.varType == 'subheader' || items[i].data.varType == 'checkbox') {
            if(items[i].data.varHidden){
              this.tempSchema[items[i].data.varName].class += " hidden-spacer";

              if(items[i].data.varType == 'file') {
                let btnName = items[i].data.varName + "Btn";
                this.tempSchema[btnName].class += " hidden-spacer";
              }
            }
          }
        }
        
        // Add the final schema 
        let schema = this.tempSchema;
        if(groupCount == 1) {
          theSchema.forms[currentForm]['group1'] = {
              "type": "wrap",
              "col": 12,
              "elevation": 0,
              "ripple": false,
              schema
            };
        }else if(Object.keys(schema).length != 0) {
          let lastGroup = 'group' + groupCount;
          theSchema.forms[currentForm][lastGroup] = {
              "type": "wrap",
              "col": 12,
              "elevation": 0,
              "ripple": false,
              schema
            };
        }
        this.formSchema = JSON.parse(JSON.stringify(theSchema));
        
        if(action == 'save') {
          this.saveForm(this.availableVars);
        }
        if(action == 'build') {
          this.$store.commit('PREVIEW_LOADED', true);
        }
        this.resetDefaults();
      },
      deleteField(elementId) {
        this.editElementDialog = false;
        for(let j = 0; j < this.layout.length; j++) {
          if(this.layout[j].i === elementId) {
            // Remove default value if it exists
            if(this.layout[j].data.varValue !== null) {
              this.formModel[this.layout[j].data.varName] = null;
            }
            // Decrement groups if necessary
            if(this.layout[j].data.varType == 'group') {
              this.groups--;
            }
            // Decrement forms if necessary
            if(this.layout[j].data.varType == 'page') {
              this.formCount--;
            }
            // Decrement paragraphs if necessary
            if(this.layout[j].data.varType == 'para') {
              this.paragraphs--;
            }
            // Remove item from layout
            this.layout.splice(j, 1);
            break;
          }
        }

        // Reindex grid
        let gridIndex = 0;
        for(let k = 0; k < this.layout.length; k++) {
          this.layout[k].i = gridIndex;
          gridIndex++;
        }

        this.resetDefaults();
      },
      addNewRow() {
        this.addRowTitle = this.$t('FORMS.NEW_EDIT_FORM.FIELDS.ADD_ROW_TITLE');
        this.addRowDialog = true;
        this.setTabs();
        if(typeof this.$refs.addRow !== 'undefined') {
          this.$refs.addRow.resetValidation();
        }
      },
      cancelAddRow() {
        this.addRowDialog = false;
        this.itemName = '';
        this.itemValue = '';
        this.itemType = '';
        this.itemWidth = 2;
        this.configVarValue = null;
        this.configVarIsEmail = null;
        this.configVarAutocalc = null;
        this.configEnableSql = false;
        this.configFieldConnId = 0;
        this.configFieldSql = null;
        this.configVarAllowMultiple = null;
        this.configSelectItems = [];
        this.configCheckboxItems = [];
        this.configComboItems = [];
        this.$refs.addRow.resetValidation();
      },
      confirmAddRow() {
        this.addRowDialog = false;
        if(this.varType == 'radio') {
          this.radioItems.push({ label: this.itemName, value: this.itemValue });
          this.reorderItems('radioItems');
        }
        if(this.varType == 'select' || this.varType == 'autocomplete') {
          this.selectItems.push({ itemText: this.itemName, itemValue: this.itemValue });
          this.reorderItems('selectItems');
        }
        if(this.varType == 'checkbox') {
          this.checkboxItems.push({ label: this.itemName, variableName: this.itemValue, width: this.itemWidth });
          this.reorderItems('checkboxItems');
        }
        if(this.varType == 'combobox') {
          this.comboItems.push({ itemName: this.itemName });
          this.reorderItems('comboItems');
        }
        if(this.varType == 'array') {
          if(!this.configEnableSql) {
            this.configFieldConnId = 0;
            this.configFieldSql = '';
          }
          this.gridItems.push({ fieldName: this.itemName, fieldVarName: this.itemValue, fieldType: this.itemType, fieldWidth: this.itemWidth, fieldDefault: this.configVarValue, fieldEmail: this.configVarIsEmail, fieldAuto: this.configVarAutocalc, enableSql: this.configEnableSql, fieldConnId: this.configFieldConnId, fieldSql: this.configFieldSql, fieldMulti: this.configVarAllowMultiple, configSelectItems: this.configSelectItems, configCheckboxItems: this.configCheckboxItems, configComboItems: this.configComboItems });
          this.reorderItems('gridItems');
        }
        this.itemName = '';
        this.itemValue = '';
        this.itemType = '';
        this.itemWidth = 2;
        this.configVarValue = null;
        this.configVarIsEmail = null;
        this.configVarAutocalc = null;
        this.configEnableSql = false;
        this.configFieldConnId = 0;
        this.configFieldSql = null;
        this.configVarAllowMultiple = null;
        this.configSelectItems = [];
        this.configCheckboxItems = [];
        this.configComboItems = [];
        this.$refs.addRow.resetValidation();
        
        if(typeof this.$refs.newElement !== 'undefined') {
          this.isFieldValid = this.$refs.newElement.validate();
        }
        if(typeof this.$refs.editElement !== 'undefined') {
          this.isFieldValid = this.$refs.editElement.validate();
        }
      },
      editRow(index) {
        this.editRowTitle = this.$t('FORMS.NEW_EDIT_FORM.FIELDS.EDIT_ROW_TITLE');
        this.rowIndex = index;
        if(this.varType == 'radio') {
          this.itemName = this.radioItems[index].label;
          this.itemValue = this.radioItems[index].value;
        }
        if(this.varType == 'select' || this.varType == 'autocomplete') {
          this.itemName = this.selectItems[index].itemText;
          this.itemValue = this.selectItems[index].itemValue;
        }
        if(this.varType == 'checkbox') {
          this.itemName = this.checkboxItems[index].label;
          this.itemValue = this.checkboxItems[index].variableName;
          this.itemWidth = this.checkboxItems[index].width;
        }
        if(this.varType == 'combobox') {
          this.itemName = this.comboItems[index].itemName;
        }
        if(this.varType == 'array') {
          this.itemName = this.gridItems[index].fieldName;
          this.itemValue = this.gridItems[index].fieldVarName;
          this.itemType = this.gridItems[index].fieldType;
          this.itemWidth = this.gridItems[index].fieldWidth;
          this.configVarValue = this.gridItems[this.rowIndex].fieldDefault;
          this.configVarIsEmail = this.gridItems[this.rowIndex].fieldEmail;
          this.configVarAutocalc = this.gridItems[this.rowIndex].fieldAuto;
          this.configEnableSql = this.gridItems[this.rowIndex].enableSql;
          this.configFieldConnId = this.gridItems[this.rowIndex].fieldConnId;
          this.configFieldSql = this.gridItems[this.rowIndex].fieldSql;
          this.configVarAllowMultiple = this.gridItems[this.rowIndex].fieldMulti;
          this.configSelectItems = this.gridItems[this.rowIndex].configSelectItems;
          this.configCheckboxItems = this.gridItems[this.rowIndex].configCheckboxItems;
          this.configComboItems = this.gridItems[this.rowIndex].configComboItems;
          this.reorderItems('configSelectItems');
          this.reorderItems('configCheckboxItems');
          this.reorderItems('configComboItems');
        }
        this.editRowDialog = true;
        this.setTabs();
      },
      cancelEditRow() {
        this.editRowDialog = false;
        this.itemName = '';
        this.itemValue = '';
        this.itemType = '';
        this.itemWidth = 2;
        this.configVarValue = null;
        this.configVarIsEmail = null;
        this.configVarAutocalc = null;
        this.configEnableSql = false;
        this.configFieldConnId = 0;
        this.configFieldSql = null;
        this.configVarAllowMultiple = null;
        this.configSelectItems = [];
        this.configCheckboxItems = [];
        this.configComboItems = [];
        this.$refs.editRow.resetValidation();
      },
      confirmEditRow() {
        this.editRowDialog = false;
        if(this.varType == 'radio') {
          this.radioItems[this.rowIndex].label = this.itemName;
          this.radioItems[this.rowIndex].value = this.itemValue;
        }
        if(this.varType == 'select' || this.varType == 'autocomplete') {
          this.selectItems[this.rowIndex].itemText = this.itemName;
          this.selectItems[this.rowIndex].itemValue = this.itemValue;
        }
        if(this.varType == 'checkbox') {
          this.checkboxItems[this.rowIndex].label = this.itemName;
          this.checkboxItems[this.rowIndex].variableName = this.itemValue;
          this.checkboxItems[this.rowIndex].width = this.itemWidth;
        }
        if(this.varType == 'combobox') {
          this.comboItems[this.rowIndex].itemName = this.itemName;
        }
        if(this.varType == 'array') {
          if(!this.configEnableSql) {
            this.configFieldConnId = 0;
            this.configFieldSql = '';
          }

          this.gridItems[this.rowIndex].fieldName = this.itemName;
          this.gridItems[this.rowIndex].fieldVarName = this.itemValue;
          this.gridItems[this.rowIndex].fieldType = this.itemType;
          this.gridItems[this.rowIndex].fieldWidth = this.itemWidth;
          this.gridItems[this.rowIndex].fieldDefault = this.configVarValue;
          this.gridItems[this.rowIndex].fieldEmail = this.configVarIsEmail;
          this.gridItems[this.rowIndex].fieldAuto = this.configVarAutocalc;
          this.gridItems[this.rowIndex].enableSql = this.configEnableSql;
          this.gridItems[this.rowIndex].fieldConnId = this.configFieldConnId;
          this.gridItems[this.rowIndex].fieldSql = this.configFieldSql;
          this.gridItems[this.rowIndex].fieldMulti = this.configVarAllowMultiple;
          this.gridItems[this.rowIndex].configSelectItems = this.configSelectItems;
          this.gridItems[this.rowIndex].configCheckboxItems = this.configCheckboxItems;
          this.gridItems[this.rowIndex].configComboItems = this.configComboItems;
        }
        this.itemName = '';
        this.itemValue = '';
        this.itemType = '';
        this.itemWidth = 2;
        this.configVarValue = null;
        this.configVarIsEmail = null;
        this.configVarAutocalc = null;
        this.configEnableSql = false;
        this.configFieldConnId = 0;
        this.configFieldSql = null;
        this.configVarAllowMultiple = null;
        this.configSelectItems = [];
        this.configCheckboxItems = [];
        this.configComboItems = [];
        this.$refs.editRow.resetValidation();
      },
      addConfigRow() {
        this.addConfigRowTitle = this.$t('FORMS.NEW_EDIT_FORM.FIELDS.ADD_ITEM_TITLE');
        this.addConfigRowDialog = true;
        this.setTabs();
      },
      cancelAddConfigRow() {
        this.addConfigRowDialog = false;
        this.configItemName = '';
        this.configItemValue = '';
        this.configItemWidth = 2;
        this.$refs.addConfigRow.resetValidation();
      },
      confirmAddConfigRow() {
        this.addConfigRowDialog = false;
        if(this.itemType == 'select' || this.itemType == 'autocomplete') {
          this.configSelectItems.push({ itemText: this.configItemName, itemValue: this.configItemValue });
          this.reorderItems('configSelectItems');
        }
        if(this.itemType == 'checkbox') {
          this.configCheckboxItems.push({ label: this.configItemName, variableName: this.configItemValue, width: this.configItemWidth });
          this.reorderItems('configCheckboxItems');
        }
        if(this.itemType == 'combobox') {
          this.configComboItems.push({ itemName: this.configItemName });
          this.reorderItems('configComboItems');
        }
        this.configItemName = '';
        this.configItemValue = '';
        this.configItemWidth = 2;
        this.$refs.addConfigRow.resetValidation();

        if(typeof this.$refs.addRow !== 'undefined') {
          this.isElementValid = this.$refs.addRow.validate();
        }
        if(typeof this.$refs.editRow !== 'undefined') {
          this.isElementValid = this.$refs.editRow.validate();
        }
      },
      editConfigRow(index) {
        this.editConfigRowTitle = this.$t('FORMS.NEW_EDIT_FORM.FIELDS.EDIT_ITEM_TITLE');
        this.configRowIndex = index;
        if(this.itemType == 'select' || this.itemType == 'autocomplete') {
          this.configItemName = this.configSelectItems[index].itemText;
          this.configItemValue = this.configSelectItems[index].itemValue;
        }
        if(this.itemType == 'checkbox') {
          this.configItemName = this.configCheckboxItems[index].label;
          this.configItemValue = this.configCheckboxItems[index].variableName;
          this.itemWidth = this.configCheckboxItems[index].width;
        }
        if(this.itemType == 'combobox') {
          this.configItemName = this.configComboItems[index].itemName;
        }
        this.editConfigRowDialog = true;
        this.setTabs();
      },
      cancelEditConfigRow() {
        this.editConfigRowDialog = false;
        this.configItemName = '';
        this.configItemValue = '';
        this.configItemWidth = 2;
        this.$refs.editConfigRow.resetValidation();
      },
      confirmEditConfigRow() {
        this.editConfigRowDialog = false;
        if(this.itemType == 'select' || this.itemType == 'autocomplete') {
          this.configSelectItems[this.configRowIndex].itemText = this.configItemName;
          this.configSelectItems[this.configRowIndex].itemValue = this.configItemValue;
        }
        if(this.itemType == 'checkbox') {
          this.configCheckboxItems[this.configRowIndex].label = this.configItemName;
          this.configCheckboxItems[this.configRowIndex].variableName = this.configItemValue;
          this.configCheckboxItems[this.configRowIndex].width = this.configItemWidth;
        }
        if(this.itemType == 'combobox') {
          this.configComboItems[this.configRowIndex].itemName = this.configItemName;
        }
        this.configItemName = '';
        this.configItemValue = '';
        this.configItemWidth = 2;
        this.$refs.editConfigRow.resetValidation();

        if(typeof this.$refs.addRow !== 'undefined') {
          this.isElementValid = this.$refs.addRow.validate();
        }
        if(typeof this.$refs.editRow !== 'undefined') {
          this.isElementValid = this.$refs.editRow.validate();
        }
      },
      deleteConfigRow(item) {
        if(this.itemType == 'select' || this.itemType == 'autocomplete') {
          this.configSelectItems.splice(item, 1);
          this.reorderItems('configSelectItems');
        }
        if(this.itemType == 'checkbox') {
          this.configCheckboxItems.splice(item, 1);
          this.reorderItems('configCheckboxItems');
        }
        if(this.itemType == 'combobox') {
          this.configComboItems.splice(item, 1);
          this.reorderItems('configComboItems');
        }
      },
      deleteRow(item) {
        if(this.varType == 'radio') {
          this.radioItems.splice(item, 1);
          this.reorderItems('radioItems');
        }
        if(this.varType == 'select' || this.varType == 'autocomplete') {
          this.selectItems.splice(item, 1);
          this.reorderItems('selectItems');
        }
        if(this.varType == 'checkbox') {
          this.checkboxItems.splice(item, 1);
          this.reorderItems('checkboxItems');
        }
        if(this.varType == 'combobox') {
          this.comboItems.splice(item, 1);
          this.reorderItems('comboItems');
        }
        if(this.varType == 'array') {
          this.gridItems.splice(item, 1);
          this.reorderItems('gridItems');
        }
      },
      moveItemUp(id, items) {
        let from = id;
        let to = id - 1;
        if(items == 'configSelectItems') {
          this.configSelectItems.splice(to, 0, this.configSelectItems.splice(from, 1)[0]);
        }
        if(items == 'configCheckboxItems') {
          this.configCheckboxItems.splice(to, 0, this.configCheckboxItems.splice(from, 1)[0]);
        }
        if(items == 'configComboItems') {
          this.configComboItems.splice(to, 0, this.configComboItems.splice(from, 1)[0]);
        }
        if(items == 'gridItems') {
          this.gridItems.splice(to, 0, this.gridItems.splice(from, 1)[0]);
        }
        if(items == 'comboItems') {
          this.comboItems.splice(to, 0, this.comboItems.splice(from, 1)[0]);
        }
        if(items == 'checkboxItems') {
          this.checkboxItems.splice(to, 0, this.checkboxItems.splice(from, 1)[0]);
        }
        if(items == 'selectItems') {
          this.selectItems.splice(to, 0, this.selectItems.splice(from, 1)[0]);
        }
        if(items == 'radioItems') {
          this.radioItems.splice(to, 0, this.radioItems.splice(from, 1)[0]);
        }
        if(items == 'queryItems') {
          this.queryItems.splice(to, 0, this.queryItems.splice(from, 1)[0]);
        }
        this.reorderItems(items);
      },
      moveItemDown(id, items) {
        let from = id;
        let to = id + 1;
        if(items == 'configSelectItems') {
          this.configSelectItems.splice(to, 0, this.configSelectItems.splice(from, 1)[0]);
        }
        if(items == 'configCheckboxItems') {
          this.configCheckboxItems.splice(to, 0, this.configCheckboxItems.splice(from, 1)[0]);
        }
        if(items == 'configComboItems') {
          this.configComboItems.splice(to, 0, this.configComboItems.splice(from, 1)[0]);
        }
        if(items == 'gridItems') {
          this.gridItems.splice(to, 0, this.gridItems.splice(from, 1)[0]);
        }
        if(items == 'comboItems') {
          this.comboItems.splice(to, 0, this.comboItems.splice(from, 1)[0]);
        }
        if(items == 'checkboxItems') {
          this.checkboxItems.splice(to, 0, this.checkboxItems.splice(from, 1)[0]);
        }
        if(items == 'selectItems') {
          this.selectItems.splice(to, 0, this.selectItems.splice(from, 1)[0]);
        }
        if(items == 'radioItems') {
          this.radioItems.splice(to, 0, this.radioItems.splice(from, 1)[0]);
        }
        if(items == 'queryItems') {
          this.queryItems.splice(to, 0, this.queryItems.splice(from, 1)[0]);
        }
        this.reorderItems(items);
      },
      reorderItems(items) {
        if(items == 'configSelectItems') {
          for(let i = 0; i < this.configSelectItems.length; i++) {
            this.configSelectItems[i].id = i;
          }
        }
        if(items == 'configCheckboxItems') {
          for(let i = 0; i < this.configCheckboxItems.length; i++) {
            this.configCheckboxItems[i].id = i;
          }
        }
        if(items == 'configComboItems') {
          for(let i = 0; i < this.configComboItems.length; i++) {
            this.configComboItems[i].id = i;
          }
        }
        if(items == 'gridItems') {
          for(let i = 0; i < this.gridItems.length; i++) {
            this.gridItems[i].id = i;
          }
        }
        if(items == 'comboItems') {
          for(let i = 0; i < this.comboItems.length; i++) {
            this.comboItems[i].id = i;
          }
        }
        if(items == 'checkboxItems') {
          for(let i = 0; i < this.checkboxItems.length; i++) {
            this.checkboxItems[i].id = i;
          }
        }
        if(items == 'selectItems') {
          for(let i = 0; i < this.selectItems.length; i++) {
            this.selectItems[i].id = i;
          }
        }
        if(items == 'radioItems') {
          for(let i = 0; i < this.radioItems.length; i++) {
            this.radioItems[i].id = i;
          }
        }
        if(items == 'queryItems') {
          for(let i = 0; i < this.queryItems.length; i++) {
            this.queryItems[i].id = i;
          }
        }
      },
      openJsEditor() {
        this.jsDialog = true;
      },
      saveJs(item) {
        this.jsDialog = false;
        this.extScript = item.extScript;
        this.lastScript = this.extScript;
      },
      closeJs() {
        this.jsDialog = false;
        
        if(this.editorChange) {
          this.resetEditor();
        }
      },
      resetEditor() {
        let reset = this.editorState.update({changes: {from:0, to: this.editorState.doc.length, insert: this.lastScript}});
        this.editorView.update([reset]);
      },
      drag() {
        let parentRect = document.getElementById('content').getBoundingClientRect();
        let mouseInGrid = false;
        if (((mouseXY.x > parentRect.left) && (mouseXY.x < parentRect.right)) && ((mouseXY.y > parentRect.top) && (mouseXY.y < parentRect.bottom))) {
          mouseInGrid = true;
        }
        if (mouseInGrid === true && (this.layout.findIndex(item => item.i === 'drop')) === -1) {
          this.layout.push({
            x: (this.layout.length * 2) % (this.colNum || 12),
            y: this.layout.length + (this.colNum || 12), // puts it at the bottom
            w: 3,
            h: 1,
            i: 'drop',
            data: '',
            elementType: '',
            isLocked: false
          });
        }
        let index = this.layout.findIndex(item => item.i === 'drop');
        if (index !== -1) {
          try {
            this.$refs.gridlayout.$children[this.layout.length].$refs.item.style.display = "none";
          } catch {
            // console.log(e);
          }
          let el = this.$refs.gridlayout.$children[index];
          el.dragging = {"top": mouseXY.y - parentRect.top, "left": mouseXY.x - parentRect.left};
          let new_pos = el.calcXY(mouseXY.y - parentRect.top, mouseXY.x - parentRect.left);
          if (mouseInGrid === true) {
            this.$refs.gridlayout.dragEvent('dragstart', 'drop', new_pos.x, new_pos.y, 1, 3);
            DragPos.i = String(index);
            DragPos.x = this.layout[index].x;
            DragPos.y = this.layout[index].y;
          }
          if (mouseInGrid === false) {
            this.$refs.gridlayout.dragEvent('dragend', 'drop', new_pos.x, new_pos.y, 1, 3);
            this.layout = this.layout.filter(obj => obj.i !== 'drop');
          }
        }
      },
      addField(type, elementType) {
        let x = 0;
        let y = 0;
        let i = 0;

        // Sory by y, then get last element in layout
        this.layout.sort((a, b) => parseFloat(a.y) - parseFloat(b.y));
        let lastY = this.layout[this.layout.length - 1];

        // Sory by i, then get last element in layout
        this.layout.sort((a, b) => parseFloat(a.i) - parseFloat(b.i));
        let lastI = this.layout[this.layout.length - 1];

        if(typeof lastY !== 'undefined') {
          y = lastY.y + 1;
          i = lastI.i + 1;
        }

        if(type == 'page') {
          y = y + 2;
        }

        let width = 3;
        if(type == 'group' || type == 'checkbox' || type == 'radio') {
          width = 12;
        }

        this.layout.push({
          x: x,
          y: y,
          w: width,
          h: 1,
          i: i,
          data: '',
          elementType: elementType,
          isLocked: false
        });
        
        this.currentElementId = i;
        this.varOffset = x;
        this.newElement(type, elementType);
      },
      dragMoved(item) {
        this.currentElementId = item.i;
        this.varAction = 'moved';
        this.updateElement(item);
      },
      dragResized(item) {
        this.currentElementId = item.i;
        this.varAction = 'resized';
        this.updateElement(item);
      },
      snackSave () {
        if(this.allOk) {
          this.snack = true
          this.snackColor = 'success'
          this.snackText = 'Data saved'
        }
      },
      snackCancel () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Canceled'
      },
      snackError () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'This variable name already exists. Please choose another name.'
      },
      snackExists () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'A form with this title already exists. Please enter a different title.'
      },
      snackErrorMessage () {
        this.snack = true;
        this.snackTimeout = 10000;
        this.snackColor = 'error';
        this.snackText = this.errorMessage + '. Please contact your System Administrator.';
        this.allOk = false;
      },
      updateLog(cat, op, msg) {
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        let logData = {
          'category': cat,
          'userId': this.$store.state.currentUser,
          'caseId': 0,
          'processName': null,
          'taskName': null,
          'operation': op,
          'msg': msg,
          'dateTime': dateTime,
        };
        this.$store.dispatch('updateOpLog', logData);
      }
    }
  }
</script>

<style>
  .theme--light.v-stepper {
    background: #e0e0e0;
  }
  .build-content {
    height: calc(100vh - 245px);
    overflow: auto;
    max-width: none;
  }
  .v-speed-dial__list .v-btn {
    width: 132px;
    color: white;
    top: -20px;
  }
  .form-elements-container {
    position: absolute;
    right: 0;
  }
  .form-elements-header {
    justify-content: center;
  }
  .form-elements {
    height: calc(100vh - 355px);
    overflow: auto;
  }
  .form-elements > .inner {
    height: 100%;
  }
  .truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
  .form-element {
    height: 40px;
    margin-bottom: 4px;
    cursor: pointer;
  }
  .lock-element {
    position: absolute;
    top: 2px;
    right: 0px;
    cursor: pointer;
  }
  .element-type {
    color: gray;
  }
  .edit-element {
    position: absolute;
    bottom: 10px;
    left: 2px;
    cursor: pointer;
  }
  .hidden-spacer {
    display: none;
  }
  .vue-grid-layout {
    min-height: 50px;
    background: #eee;
  }
  .vue-grid-item:not(.vue-grid-placeholder) {
      background: #ccc;
      border: 1px solid orange;
      border-radius: 5px;
      touch-action: none;
  }
  .vue-grid-item .resizing {
      opacity: 0.9;
  }
  .vue-grid-item .static {
      background: #cce;
  }
  .vue-grid-item .text {
      font-size: 24px;
      text-align: center;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      height: 100%;
      width: 100%;
  }
  .vue-grid-item .no-drag {
      height: 100%;
      width: 100%;
  }
  .vue-grid-item .minMax {
      font-size: 12px;
  }
  .vue-grid-item .add {
      cursor: pointer;
  }
  .vue-draggable-handle {
      position: absolute;
      width: 20px;
      height: 20px;
      top: 0;
      left: 0;
      background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>") no-repeat;
      background-position: bottom right;
      padding: 0 8px 8px 0;
      background-repeat: no-repeat;
      background-origin: content-box;
      box-sizing: border-box;
      cursor: pointer;
  }
  .grid-element {
    border: 1px solid orange;
    padding: 10px 0;
    margin: 15px 0;
  }
  .subform-border-solid {
    border: 1px solid orange !important;
    background-color: #e0e0e0 !important;
    padding: 10px;
    margin: 15px 0;
  }
  .subform-border-dashed {
    border: 1px dashed orange !important;
    background-color: #e0e0e0 !important;
    padding: 10px;
    margin: 15px 0;
  }
  .image-border {
    margin: 15px 0;
  }
  .para-height {
    height: 100%;
    margin-bottom: 20px;
  }
  .v-input .v-label {
    line-height: 10px;
    left: 10px !important;
  }
  .v-input__prepend-outer {
    margin-top: 10px !important;
  }
  .v-input input,
  .v-input .v-select__selections {
    padding-left: 10px !important;
  }
  .check-grid-item .v-label {
    top: -1px !important;
    left: 10px !important;
  }
  .v-label.v-label--active {
    top: 10px !important;
    font-size: 18px !important;
  }
  .js-dialog {
    max-height: 95% !important;
  }
  .js-dialog .v-card {
    height: 100%;
  }
  .vue-codemirror {
    height: calc(100vh - 305px);
  }
  .editor-wrapper .cm-editor {
    height: 100% !important;
  }
  .editor-wrapper .cm-scroller {
    height: 100% !important;
  }
</style>